<template>
	<div id="meeting" style="min-width: 1000px;">
		<div class="container">
			<div class="sortContainer" style="background: #fff;">
				<div class="applyContainer" v-if="false">
                    <div class="item" style="background:#FBF1E5;" @click="corporateApply">
                    	<div class="left">
                    		<div class="subheading">
                    			<div class="title">万企线上招聘会</div>
                    			<div class="applyLink">去报名 ›</div>
                    		</div>
                    		<div class="description">每月10号企业集中在线招聘&nbsp;学生在线求职</div>
                    	</div>
                    	<div class="right">
                    		<img src="../img/applyImg1.png" style="width: 46px;height: 40px;" alt="" />
                    	</div>
                    </div>
					<div class="item" style="background:#EAF0FC;" @click="toWednesday">
						<div class="left">
							<div class="subheading">
								<div class="title">名企校招宣讲</div>
								<div class="applyLink">去报名 ›</div>
							</div>
							<div class="description">一站面向全国高校线上宣讲 &nbsp;招聘品宣双赢</div>
						</div>
						<div class="right">
							<img src="../img/applyImg2.png" style="width: 35px;height: 40px;" alt="" />
						</div>
					</div>

					<div class="item" @click="toJobShadowing">
						<div class="left">
							<div class="subheading">
								<div class="title">学生访企探岗</div>
								<div class="applyLink">去报名 ›</div>
							</div>
							<div class="description">组织对口学生进企探访和应聘&nbsp;企业免费参加</div>
						</div>
						<div class="right">
							<img src="../img/applyImg3.png" alt="" style="width: 42px;height: 40px;" />
						</div>
					</div>

					

				</div>


				<div class="screenContainer">
					<div class="searchContainer">
						<div class="screenItem" style="margin-top: 6px;margin-bottom: 5px;">
							<div class="left">
								省份
							</div>
							<div class="item" :class="majors[0].isSelect ?'active':''" @click="selectProvince(0)">
								全部
							</div>
							<div class="right">
								<div class="item" :class="item.isSelect?'active':''" @click="selectProvince(index)"
									v-for="(item,index) in majors" :key='index' v-if="index>0">
									{{item.name}}
								</div>
							</div>
						</div>

						<div class="screenItem">
							<div class="left">
								类型
							</div>
							<div class="right">
								<div class="item" :class="item.isSelect?'active':''" @click="selectgradation(index)"
									v-for="(item,index) in gradation" :key='index'>
									{{item.name}}
								</div>
								<!-- <div class="item" :class="isFreeMeeting ? 'active' : ''" @click="selectFreeMeeting">
									免费场
								</div> -->
							</div>
						</div>

						<!-- <div class="screenItem">
							<div class="left">
								费用
							</div>
							<div class="right">
								<div class="item" :class="item.isSelect?'active':''" @click="selectexpense(index)"
									v-for="(item,index) in expense" :key='index'>
									{{item.name}}
								</div>
							</div>
						</div>

						<div class="screenItem">
							<div class="left">
								类型
							</div>
							<div class="right">
								<div class="item" :class="item.isSelect?'active':''" @click="selecttypeList(index)"
									v-for="(item,index) in typeList" :key='index'>
									{{item.name}}
								</div>
							</div>
						</div> -->
					</div>

					<div class="" style="display: flex;flex-direction: column;justify-content: space-between;">
						<div class="" style="display: flex;margin-bottom: 5px;">
							<div class="btnContainer" style="margin-right: 10px;">
								<div class="searchLeft">
									<img src="../img/search2.png" alt="" />
									<input type="text" v-model="searchName" @keyup.enter="search" placeholder-style="color:red"
										placeholder="学校/双选会名称" />
								</div>
								<div class="btn" @click="search">
									<div style="font-weight: 600;">搜索</div>
								</div>
								<div v-if="searchName" style="margin-left: 5px;" class="btn" @click="resetSearch">
									<div style="font-weight: 600;">重置</div>
								</div>
							</div>
							<div class=""
								style="background: #1E40AF;margin-left: 0;width: 100px;height: 39px;display: flex;align-items: center;justify-content: center;border-radius: 5px;font-size: 0;cursor: pointer;"
								@click="postPosition">
								<div style="font-weight: 400;font-size: 14px;color: #ffffff;">
									我的报名{{regLength?'·'+regLength:''}}
								</div>
							</div>
						</div>

						<!-- <div class="" style="display: flex;justify-content: flex-end;align-items: center;" v-if="showLine">
							<div class="" style="color: #333;font-size: 14px;margin-right: 10px;">
								按线路选择
							</div>
							<el-switch v-model="isApply" @change='applyChange' active-color="#1E40AF">
							</el-switch>
						</div> -->
					</div>




				</div>
			</div>
			<!-- <div class="sortContainer" style="position: fixed;top: 56px;z-index: 100;background: #fff;">
				<div class="screenContainer">
					<div class="searchContainer">
						<div class="searchItem">
							<div class="iptName">类型：</div>
							<el-select @change="changeMeeting" v-model="headIndex" placeholder="请选择类型">
								<el-option v-for="item in typeList" :key="item.value" :label="item.label"
									:value="item.value"> </el-option>
							</el-select>
						</div>
						<div class="searchItem">
							<div class="iptName iptName1">省份：</div>
							<div class="majorbox" @click="selectcityBox3">
								<div class="majorBox one-line"
									:style="academy_feature.length > 0 ? '' : 'color:#c0c4cc;'">
									{{ academy_feature.length > 0 ? academy_feature.join('，') : '请选择省份' }}
								</div>
								<i class="el-icon-arrow-down" style="color: #c0c4cc"></i>
							</div>
						</div>
						<div class="searchItem">
							<div class="iptName iptName1">学校层次：</div>
							<el-select v-model="education" @change="changeMeetingLevel" placeholder="学校层次">
								<el-option v-for="(item, index) in eduList" :key="index" :label="item" :value="item">
								</el-option>
							</el-select>
						</div>
						<div class="searchItem">
							<div class="iptName iptName1">收费：</div>
							<el-select v-model="isFree" @change="changeIsFree" placeholder="收费">
								<el-option v-for="(item, index) in freeList" :key="index" :label="item" :value="item">
								</el-option>
							</el-select>
						</div>
					</div>

					<div class="" style="display: flex;align-items: center;">
						<div class="btnContainer" style="margin-right: 10px;">
							<div class="searchLeft">
								<img src="../img/search2.png" alt="" />
								<input type="text" v-model="searchName" placeholder-style="color:red"
									placeholder="搜索双选会名称" />
							</div>
							<div class="btn" @click="search">
								<div>搜索</div>
							</div>
						</div>
						<div class=""
							style="background: #1E40AF;margin-left: 10px;width: 100px;height: 39px;display: flex;align-items: center;justify-content: center;border-radius: 5px;font-size: 0;cursor: pointer;"
							@click="postPosition">
							<div style="font-weight: 400;font-size: 14px;color: #ffffff;">
								我的报名{{regLength?'·'+regLength:''}}
							</div>
						</div>
					</div>
				</div>
			</div> -->
			<!-- <img src="https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2026/05/14/pw0ripxuach24v7e.png"
				style="width:90px; height:72px;"
				alt="双选会海报"> -->


			<div class="listContainer">
				<!-- <div class="title">
					生源列表
				</div> -->
				<!-- <div class="" style="width: 100%;height: 113px;">

				</div> -->

				<div class="tableContainer" v-loading="loading">
					<!-- <ul class="infinite-list" v-infinite-scroll="load" infinite-scroll-immediate='false' style="overflow:auto;height: 602px;"> -->

					<div class="tableHeader" style="border: 1px solid #e9eeff;position: sticky;top: 0;z-index: 100;">
						<div class="" style="width: 50px;">
							<!-- <el-checkbox v-model="allChecked" @change='allSelect' v-if="isApply"></el-checkbox> -->
						</div>
						<div class="routeColumn">
							千校招聘线路
						</div>
						<div class="meetingTimeColumn">
							举办时间
						</div>
						<div class="commonColumn">
							举办形式
						</div>
						<div class="commonColumn" v-if="false">
							报名截止
						</div>
						<div class="feeColumn commonColumn" v-if="nextToken">
							费用
						</div>
						<!-- <div class="feeColumn commonColumn">
							服务费
						</div> -->
						<div class="commonColumn">
							报名
						</div>
					</div>
					
					<!-- <ul class="infinite-list" >
					    <li v-for="i in count" class="infinite-list-item">{{ i }}</li>
					</ul>height="calc(100vh - 280px)" -->
					<div class="" v-infinite-scroll="load"
						:infinite-scroll-disabled="isMeetingInitializing || loading || isLoadingMore || noMoreMeetings" infinite-scroll-distance="100">
					
					<div class="tableBody" style="" v-if="meetlist.length>0">
						<div class="" v-for="(item,index) in meetlist" :key="index">
							<div class="">

							</div>
							<div class="" style="display: flex;align-items: center;padding: 10px 0 10px 19px; "
								v-if="isApply">
								<el-checkbox v-model="item.isSelect" :disabled="selectable2(item,index)"
									@change='someSelect(index,item)'></el-checkbox>
								<div class="" style="color: #333;font-size: 16px;margin-left: 10px;font-weight: 600;">
									{{item.isTopMeeting ? '本校线路' : item.line_name}}
								</div>
								<!-- <div class="lineDescription" v-if="!item.isTopMeeting && hide_line_list.indexOf(item.line)==-1 && (item.line_name || '').indexOf('待定') == -1">
								
									<span>免费提供进校报备、院企对接、简历推荐等增值服务</span>
									<span class="lineDescriptionDetail" @click="serviceDetailVisible = true">查看详情&nbsp;›</span>
								</div> -->
								<div class="lineSelectAll" v-if="!item.isTopMeeting && !searchName1 && hide_line_list.indexOf(item.line)==-1">
									<span>线路全选</span>
									<el-switch v-model="item.isSelect" :disabled="selectable2(item,index)"
										@change="someSelect(index,item)" active-color="#1E40AF">
									</el-switch>
								</div>
							</div>
							<div class="" style="border-radius: 10px;"
								:style="isApply?'border: 1px solid #d1d2f1;':'border: 1px solid #f9fbff;'">
									
								<div class="" v-for="(itm,idx) in item.list" :key="idx">
									<div class="" v-show="(!itm.isshow || itm.isshow == 2) && (!item.isLineCollapsed || idx < 4)">
										<div class="" style="display: flex;align-items: center;"
											:style="meeting_id==itm.id?'background:#1d2646;':''">
											<div class="checkboxContainer item" style="width: 50px;">
												<el-checkbox v-model="itm.isSelect" :disabled="selectable1(itm,idx)"
													@change='itemSelect(item,index,itm,idx)'></el-checkbox>
											</div>
											<div class="jobfairname item routeColumn">
                                                <div class="school-cover" v-if="itm.meeting_cover_img">
                                                	<img class="school-cover__background" :src="itm.meeting_cover_img" alt="" @error="handleCoverImageError" />
                                                	
                                                </div>
												<div class="school-cover" v-else  :style="itm.meeting_status == 4?'opacity:0.7':''">
													<img class="school-cover__background" :src="getCoverBackgroundUrl(itm.id, index, idx)"
														alt="" @error="handleCoverImageError" />
													<div class="school-cover__copy" :style="{ color: getCoverTextColor(itm.id, index, idx) }">
														
														<template v-if="getSchoolNameSizeClass(itm.school_name) === 'two-line'">
															<div class="school-cover__name school-cover__name--two-line"
																v-for="(nameLine, lineIndex) in getSchoolNameLines(itm.school_name)" :key="lineIndex">
																{{ nameLine | replaceDot}}
															</div>
														</template>
														<div v-else class="school-cover__name"
															:class="'school-cover__name--' + getSchoolNameSizeClass(itm.school_name)">
															{{ itm.school_name | replaceDot}}
														</div>
														<div class="school-cover__season">秋季双选会</div>
													</div>
												</div>
												<div class="item-right" style="display: flex;align-items: center;flex: 1;">
													<div>  
														<div class="item-1" :style="[meeting_id==itm.id ? { color: '#fff' } : {}, getMeetingLink(itm) ? { cursor: 'pointer' } : {},itm.meeting_status == 4? {opacity:'0.7'}: {}]"
															@click="openMeetingLink(itm)">
															{{itm.meeting_short_name || itm.meeting_name }}
														</div>
														<div v-if="itm.meeting_campus" style="margin-top: 8px;color: #999;font-size: 12px;">举办地点：{{itm.meeting_campus }}</div>
													</div>
												</div>
											</div>
                                            <div class="meetingTimeColumn" :style="itm.meeting_status == 4?'opacity:0.7':''">
                                                
                                           
											<div class="holdingTime item meetingTimeColumn" style="justify-content: center;"
												:style="meeting_id==itm.id?'color:#fff;':''">
												{{ itm.meeting_time}} {{itm.meeting_hour}}
											</div>
                                             </div>
											<div class="assemblyRoom item commonColumn"
												 :style="itm.meeting_status == 4?'justify-content: center;opacity:0.7':'justify-content: center;'">
												<div class=""
													style="display: flex;align-items: center;justify-content: center;">
													<div class="meettype"
														style=";cursor: pointer;color: #1E40AF;font-weight: 600;"
														:style="meeting_id==itm.id?'color:#fff;':''"
														@click="handleQrcode(itm)">
														线上</div>
													<div v-if="itm.meeting_cat==1" class="meettype"
														style="color: #1E40AF;font-weight: 600;margin-left: 2px;margin-right: 2px;"
														:style="meeting_id==itm.id?'color:#fff;':''">
														+ </div>
													<el-tooltip v-if="itm.meeting_cat==1" class="" effect="dark" content="暂未公布会场展位图！"
														placement="bottom-start">
														<div class="meettype"
															style="cursor: pointer;color: #1E40AF;font-weight: 600;"
															:style="meeting_id==itm.id?'color:#fff;':''"
															@click="offline(itm)">
															线下</div>
													</el-tooltip>
												</div>
											</div>
											<div class="cutOff item commonColumn" v-if="false" :style="itm.meeting_status == 4?'justify-content: center;opacity:0.7':'justify-content: center;'" >

										<div class="deadline" v-if="itm.meeting_status !=5">
													<div class="deadline" style="font-weight: 600;"
														:style="meeting_id==itm.id?'color:#fff;':''"
														v-if="(itm.meeting_status == 1)&&!itm.reg_end_time">
														报名中 {{ itm.sDay > 0 ? '剩' + itm.sDay + '天' : '' }}
													</div>
													<div class="deadline" style="font-weight: 600;"
														:style="meeting_id==itm.id?'color:#fff;':''"
														v-if="itm.meeting_status == 2">
														报名结束
													</div>
													<div class="deadline" style="font-weight: 600;"
														:style="meeting_id==itm.id?'color:#fff;':''"
												v-if="(itm.meeting_status == 6||itm.meeting_status == 4||itm.meeting_status == 1)&&itm.reg_end_time">
												{{itm.reg_end_time}}
											</div>
										</div>
										<div class="deadline" v-else
											:style="meeting_id==itm.id?'color:#fff;':''">{{itm.reg_end_time}}</div>

									</div>
									<div class="cost item feeColumn commonColumn" v-if="nextToken" :style="itm.meeting_status == 4?'justify-content: center;opacity:0.7':'justify-content: center;'"
										:class="meeting_id==itm.id?'warning-row':''">
										<div v-if="itm.meeting_status == 5" style="font-weight: 600;">
											{{itm.stand_position_price==0 || !itm.stand_position_price?'免费':itm.stand_position_price+'元'}}
										</div>
										<el-button class="payFees"
											:style="itm.meeting_status==6&&itm.website!=''?'text-decoration: underline;color: #0000EE;cursor:pointer;font-weight: 600;':'font-weight: 600;'"
											v-else-if="itm.meeting_price&&itm.meeting_price!='0'"
											@click="towebsite1(itm)" type="primary">
													{{itm.meeting_status==6&&itm.website!=''?'去官网缴费':''}}{{itm.meeting_price-itm.other_price}}元</el-button>
												<el-button style="font-weight: 600;" class="payFees" v-else-if="itm.meeting_status == 4 && itm.stand_position_price && itm.stand_position_price != '0'"
													type="primary">{{itm.stand_position_price}}元</el-button>
												<el-button style="font-weight: 600;" class="payFees payFees1" v-else
													type="primary">免费</el-button>
											</div>

											<!-- <div class="cost item feeColumn commonColumn" style="justify-content: center;"
												:class="meeting_id==itm.id?'warning-row':''">
												<el-button class="payFees"
													:style="itm.meeting_status==6&&itm.website!=''?'text-decoration: underline;color: #0000EE;cursor:pointer;font-weight: 600;':'font-weight: 600;'"
													v-if="itm.stand_position_price&&itm.stand_position_price!='0'"
													@click="towebsite1(itm)" type="primary">
													{{itm.stand_position_price}}元</el-button>
												<el-button style="font-weight: 600;" class="payFees payFees1" v-else
													type="primary">免费</el-button>
											</div> -->

											<div class="cost item commonColumn" style="justify-content: center;"
												:class="meeting_id==itm.id?'warning-row':''">
												<el-button class="compile" v-if="itm.meeting_status == 0"
													@click="toSign(itm)"
													type="primary">{{itm.meeting_status_name }}</el-button>
										<el-button class="compile"
											v-if="itm.meeting_status == 1||itm.meeting_status == 5||itm.meeting_status == 6"
													@click="toggleMeetingSelection(item,index,itm,idx)" :disabled="selectable1(itm,idx)"
													:style="isRegistered(itm) || itm.isSelect ? 'background: #999999 !important;border-color: #999999 !important;color: #fff !important;' : ''"
													type="primary">{{isRegistered(itm)?'已报名':itm.isSelect?'已选择':'选择'}}</el-button>
												<el-button class="compile" v-if="itm.meeting_status == 2"
													@click="handleClick1(itm)" type="primary">去报名</el-button>

												<el-button class="compile"
													v-if="itm.meeting_status == 3||itm.meeting_status == 4"
													style="opacity: 0.7"
													type="primary">{{itm.meeting_status_name}}</el-button>

									</div>


										</div>
										<div class=""
											style="border-bottom: 1px solid #EBEEF5;margin-left: 60px;margin-right: 20px;"
											v-if="item.list.length-1>=idx">
										</div>
										
									</div>
									
									<div class="showAllContainer"  v-if="index==0&&idx==0&&showAll" @click="toshowItems">
										<div class="showAll">
											<img src="../img/unfold.png" alt="" />
											<div class="">
												已收起{{highlightIndex-1}}场双选会，点击展开
											</div>
											<img src="../img/unfold1.png" alt="" />
										</div>
									</div>
									<div class="showAllContainer" v-if="idx == 3 && item.isLineCollapsed" @click="expandLine(item)">
										<div class="showAll">
											<img src="../img/unfold.png" alt="" />
											<div>已收起{{item.list.length - 4}}场双选会，点击查看全部</div>
											<img src="../img/unfold1.png" alt="" />
										</div>
									</div>
									
								</div>



							</div>
						</div>
						<div style="height: 100px;display: flex;align-items: center;justify-content: center;color: #909399;">
							<div v-if="isLoadingMore"><i class="el-icon-loading"></i> 加载中...</div>
							<div v-else-if="noMoreMeetings">没有更多数据了</div>
						</div>
					</div>
					
					<div class="" v-else>
						<el-empty description="暂无双选会" slot="empty"></el-empty>
					</div>
					</div>




					<!-- <el-table header-row-class-name="header-row-class-name" :data="meetlist" style="width: 100%;"
						v-loading="loading" ref="multipleTable" @select="handleSelectionChange"
						:row-class-name="tableRowClassName" @select-all='selectAll' height="calc(100vh - 280px)">

						<el-empty description="暂无双选会" slot="empty"></el-empty>

						<el-table-column type="selection" width="55" disabled :selectable='selectable'>
						</el-table-column>

						<el-table-column prop="job_type" label="双选会名称" width="370">
							<template slot-scope="scope">
								<div class="item-main-box">

									<img :src="scope.row.meeting_cover_img" alt="" />
									<div class="item-right" style="display: flex;align-items: center;">
										<div class="item-1 " :title="scope.row.meeting_short_name">
											{{ scope.row.meeting_short_name }}
										</div>
									</div>
									
								</div>
							</template>
						</el-table-column>
						<el-table-column prop="salary" label="举办时间">
							<template slot-scope="scope">
								<div class="holdingTime">
									<div class="" style="font-weight: 600;">
										{{ scope.row.meeting_time}} {{scope.row.meeting_hour}}
									</div>
									
								</div>
							</template>
						</el-table-column>

						<el-table-column prop="job_name" label="会场" width="100">
							<template slot-scope="scope">
								<div class="" style="display: flex;align-items: center;justify-content: center;">
									<div class="meettype" style=";cursor: pointer;color: #1E40AF;font-weight: 600;w"
										@click="handleQrcode(scope.row)">线上</div>
									<div class="meettype"
										style="color: #1E40AF;font-weight: 600;margin-left: 2px;margin-right: 2px;">
										+ </div>

									<div class="meettype" style="cursor: pointer;color: #1E40AF;font-weight: 600;"
										v-if="scope.row.stand_position_url" @click="offline(scope.row)">线下</div>

									<el-tooltip class="item" effect="dark" content="暂未公布会场展位图！" placement="bottom-start"
										v-else>
										<div class="meettype" style="cursor: pointer;color: #1E40AF;font-weight: 600;">
											线下</div>
									</el-tooltip>

								</div>
							</template>
						</el-table-column>

						
						<el-table-column prop="job_end_time" label="报名截止">
							<template slot-scope="scope">
								<div class="deadline" v-if="scope.row.meeting_status !=5">
									<div class="deadline" style="font-weight: 600;"
										v-if="(scope.row.meeting_status == 1)&&!scope.row.reg_end_time">
										报名中 {{ scope.row.sDay > 0 ? '剩' + scope.row.sDay + '天' : '' }}
									</div>
									<div class="deadline" style="font-weight: 600;"
										v-if="scope.row.meeting_status == 2">
										报名结束
									</div>
									<div class="deadline" style="font-weight: 600;"
										v-if="(scope.row.meeting_status == 6||scope.row.meeting_status == 4||scope.row.meeting_status == 1)&&scope.row.reg_end_time">
										{{scope.row.reg_end_time}}
									</div>
								</div>
								<div class="deadline" v-else>-</div>
							</template>
						</el-table-column>
						

						<el-table-column prop="job_end_time" label="费用" width="90">
							<template slot-scope="scope">
								<el-button class="payFees"
									:style="scope.row.meeting_status==6&&scope.row.website!=''?'text-decoration: underline;color: #0000EE;cursor:pointer;font-weight: 600;':'font-weight: 600;'"
									v-if="scope.row.meeting_price&&scope.row.meeting_price!='0'"
									@click="towebsite1(scope.row)" type="primary">
									{{scope.row.meeting_status==6&&scope.row.website!=''?'去官网缴费':''}}{{scope.row.meeting_price}}元</el-button>
								<el-button style="font-weight: 600;" class="payFees payFees1" v-else
									type="primary">免费</el-button>
							</template>
						</el-table-column>

						<el-table-column label="操作" width="120">
							<template slot-scope="scope">

								<el-button class="compile" v-if=" scope.row.meeting_status == 0" @click="toSign(scope)"
									type="primary">{{ scope.row.meeting_status_name }}</el-button>
								<el-button class="compile"
									v-if="scope.row.meeting_status == 1||scope.row.meeting_status == 6"
									@click="toSign(scope)" :style="scope.row.registered?'opacity: 0.7':''"
									type="primary">{{scope.row.registered?'已报名':'去报名'}}</el-button>
								<el-button class="compile" v-if="scope.row.meeting_status == 2"
									@click="handleClick1(scope.row)" type="primary">去报名</el-button>

								<el-button class="compile"
									v-if="scope.row.meeting_status == 3||scope.row.meeting_status == 4"
									style="opacity: 0.7" type="primary">{{ scope.row.meeting_status_name }}</el-button>

								<el-button class="compile" v-if="scope.row.meeting_status == 5" type="primary"
									@click="towebsite(scope.row)">官网报名</el-button>


							</template>
						</el-table-column>
					</el-table> -->

					<div class="paging" style="justify-content: flex-end;" v-if="meeting_num>0">
						<div class="" style="display: flex;align-items: center;">
							<!-- <div class="pagingLeft">

								<el-button @click="previousPage" :disabled='currentpage > 1?false:true'>上一页</el-button>
								<el-button @click="nextPage" :disabled='isNextPage'>下一页</el-button>
							</div> -->
							<div class="" style="font-size: 16px;color: #333;font-weight: 600;">
								已选中 <span style="color:#1E40AF;">{{meeting_num}}</span> 场，总费用 <span
									style="color:#1E40AF;">{{selectedMeetingDisplayTotal}}</span> 元
							</div>
							<div class="right" style="display: flex;align-items: center;margin-left:10px;">
								<el-button type="primary" class="signAll" :style="meeting_num==0?'opacity: 0.5;':''"
									:disabled='meeting_num==0'
									@click="signAll1">去报名</el-button> <!-- {{meeting_num==0?'':'·'+meeting_num}} -->
							</div>
						</div>
						<!-- <el-pagination background layout="total,sizes,prev, pager, next" :page-sizes="[10, 20, 50]"
							:total="total" @current-change="currentChange" @size-change="handleSizeChange"
							:current-page="currentpage"> </el-pagination> -->
					</div>


				</div>





				
			</div>
		</div>

		<div class="preview">
			<el-dialog :visible.sync="dialogVisible" :show-close="false" width="550px">
				<div class="elDialog">
					<img class="close" @click="closeElDialog" src="../img/close.png" alt="" />
					<div class="main">
						<div class="title">线上会场码</div>
						<div class="qrcodeContainer">
							<div class="qrcode">
								<div class="qrcodeImage">
									<img class="qrcodeImg" :src="qrcodeImg || 'https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2026/05/13/dj8ukf7j9xlmlc5a.jpg'" alt="" />
									<img class="qrcodeLogo" src="https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2026/06/02/logopt.png" alt="" />
								</div>

								<div class="hite1">扫二维码进入线上会场</span></div>
								<!-- <div class="hite2">扫码识别二维码进入线上会场</div> -->
							</div>
						</div>
					</div>
				</div>
			</el-dialog>
		</div>

		<div class="preview">
			<el-dialog :visible.sync="dialogVisible1" :show-close="false" width="500px">
				<div class="elDialog">
					<img class="close" @click="closeElDialog1" src="../img/close.png" alt="" />
					<div class="main">
						<div class="title">双选会预览</div>
						<div class="qrcodeContainer">
							<div class="qrcode">
								<div class="qrcodeImage" v-if="qrcodeImg1">
									<img class="qrcodeImg" :src="qrcodeImg1" alt="" />
									<img class="qrcodeLogo" src="https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2026/06/02/logopt.png" alt="" />
								</div>

								<div class="hite1">扫二维码进入线上会场</div>
								<div class="hite2">可在手机上预览双选会</div>
							</div>
						</div>
					</div>
				</div>
			</el-dialog>
		</div>

		<el-dialog :visible.sync="serviceDetailVisible" custom-class="serviceDetailDialog" :show-close="false" width="450px">
			<div class="serviceDetail">
				<div class="serviceDetailHeader">
					<span style="font-weight:bold;">服务明细</span>
					<i class="el-icon-close" @click="serviceDetailVisible = false"></i>
				</div>
				<div class="serviceDetailContent">
					<p>1、进校报备：协助企业参会人员办理进校手续；</p>
					<p>2、院企对接：组织参会企业和对口院系对接；</p>
					<p>3、简历推荐：每家企业推荐30份对口简历。</p>
					
				</div>
				<div class="serviceDetailFooter">
					<el-button size="small" type="primary" @click="serviceDetailVisible = false">我知道了</el-button>
				</div>
			</div>
		</el-dialog>


		<el-dialog title="线路导入" :visible.sync="importData" :before-close="beforeClose" width="800px">
			<div class="">
				<!-- <div class="iptContainer">
					<div class="item">
						<div class="itemTitle">
							身份:
						</div>
						<div class="">
							<el-select v-model="identity" placeholder="请选择">
								<el-option v-for="(item,index) in options1" :key="index" :label="item.label"
									:value="item.value">
								</el-option>
							</el-select>
						</div>
					</div>
					<div class="item">
						<div class="itemTitle">
							对接类型:
						</div>
						<div class="">
							<el-select v-model="type" placeholder="请选择">
								<el-option v-for="item in options2" :key="item.value" :label="item.label"
									:value="item.value">
								</el-option>
							</el-select>
						</div>
					</div>
					<div class="item">
						<div class="itemTitle">
							来源:
						</div>
						<div class="">
							<el-select v-model="source" placeholder="请选择">
								<el-option v-for="item in options4" :key="item.value" :label="item.label"
									:value="item.value">
								</el-option>
							</el-select>
						</div>
					</div>
		
				</div> -->

				<div>
					<!-- :data='fileData1' -->
					<el-upload class="upload-demo" drag action="http://114.215.204.153:8089/jobinfo/doBatchImport"
						:on-success="handleAvatarSuccess1" :before-upload="beforeUpload" :show-file-list="false">
						<i class="el-icon-upload"></i>
						<div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
						<!-- <div class="el-upload__tip" slot="tip">只能上传jpg/png文件，且不超过500kb</div> -->
					</el-upload>
					<div class="" v-html="resmessage"></div>
				</div>
			</div>
		</el-dialog>
		<!-- <el-dialog title="双选会省份" ref="multipleChoice3" :visible.sync="dialogVisibleMultipleChoice4"
			:before-close="handleClose" @open="multipleOpen" @close="multipleClose" width="800px">
			<multipleChoice10 @searchWord="searchWord" @submit="multiple4" @cancel="cancel"
				:searchList="college_type_list" :selectList="academy_feature" :multipleChange="multipleChange">
			</multipleChoice10>
		</el-dialog> -->
	</div>
</template>
<script>
	import {
		mapMutations,
		mapState
	} from 'vuex'
	 const config = require('../../WebConfig')
	// import multipleChoice10 from '../components/multipleChoice10.vue'
	export default {
		components: {
			// multipleChoice10,
		},
		data() {
			return {
                hide_line_list:[531, 535, 592,630],
				expense: [{
					name: '全部',
					isSelect: true
				}, {
					name: '收费',
					isSelect: false
				}, {
					name: '免费',
					isSelect: false
				}],

				gradation: [{
					name: '全部',
					isSelect: true
				}, {
					name: '双一流',
					isSelect: false
				}, {
					name: '重点本科',
					isSelect: false
				}
				,  {
					name: '普通本科',
					isSelect: false
				},
				{
					name: '高职高专',
					isSelect: false
				}],

				typeList: [{
					name: '全部',
					isSelect: true
				}, {
					name: '线上',
					isSelect: false
				}, {
					name: '线下',
					isSelect: false
				}],
				academy_feature: [],
				majors: [{
						name: '全部',
						isSelect: true
					}, {
						name: '北京',
						isSelect: false
					},
					{
						name: '江苏',
						isSelect: false
					},
					{
						name: '上海',
						isSelect: false
					},
					{
						name: '广东',
						isSelect: false
					},

					{
						name: '湖北',
						isSelect: false
					},
					{
						name: '陕西',
						isSelect: false
					},
					{
						name: '四川',
						isSelect: false
					},
					{
						name: '浙江',
						isSelect: false
					},

					{
						name: '山东',
						isSelect: false
					},
					{
						name: '辽宁',
						isSelect: false
					},
					{
						name: '湖南',
						isSelect: false
					},
					{
						name: '安徽',
						isSelect: false
					},

					{
						name: '天津',
						isSelect: false
					},
					{
						name: '重庆',
						isSelect: false
					},
					{
						name: '福建',
						isSelect: false
					},
					{
						name: '河南',
						isSelect: false
					},

					{
						name: '黑龙江',
						isSelect: false
					},
					{
						name: '吉林',
						isSelect: false
					},
					{
						name: '河北',
						isSelect: false
					},
					{
						name: '江西',
						isSelect: false
					},

					{
						name: '广西',
						isSelect: false
					},
					{
						name: '山西',
						isSelect: false
					},
					{
						name: '云南',
						isSelect: false
					},
					{
						name: '贵州',
						isSelect: false
					},

					{
						name: '甘肃',
						isSelect: false
					},
					{
						name: '新疆',
						isSelect: false
					},
					{
						name: '内蒙古',
						isSelect: false
					},
					{
						name: '海南',
						isSelect: false
					},
					{
						name: '宁夏',
						isSelect: false
					}, {
						name: '青海',
						isSelect: false
					}, {
						name: '西藏',
						isSelect: false
					}
				],
				multipleChange: false,
				dialogVisibleMultipleChoice4: false,
				searchName: '',
				meetlist: [],
				dialogVisible: false,
				shcool_level: '',
				headIndex: '',
				options: [{
						value: '男',
						label: '男',
					},
					{
						value: '女',
						label: '女',
					},
				],
				value: '',
				value1: '',

				total: 0,
				pageSizes: 10,
				currentPage: 1,
				currentpage: 1,

				pickerOptions: {
					disabledDate(time) {
						return time.getTime() < Date.now()
					},
				},
				jobList: [],
				tableData: [{
						date1: '全职',
						date2: 'UI设计师',
						date3: '8000-10000',
						date4: '本科',
						date5: '2',
						date6: '08:30-17:30',
						date7: '2025-01-12',
						date8: '双休',
						date9: '偶尔加班',
						date10: '偶尔出差',
						date11: '预览职位',
					},
					{
						date1: '全职',
						date2: 'UI设计师',
						date3: '8000-10000',
						date4: '本科',
						date5: '2',
						date6: '08:30-17:30',
						date7: '2025-01-12',
						date8: '双休',
						date9: '偶尔加班',
						date10: '偶尔出差',
						date11: '预览职位',
					},
					{
						date1: '全职',
						date2: 'UI设计师',
						date3: '8000-10000',
						date4: '本科',
						date5: '2',
						date6: '08:30-17:30',
						date7: '2025-01-12',
						date8: '双休',
						date9: '偶尔加班',
						date10: '偶尔出差',
						date11: '预览职位',
					},
					{
						date1: '全职',
						date2: 'UI设计师',
						date3: '8000-10000',
						date4: '本科',
						date5: '2',
						date6: '08:30-17:30',
						date7: '2025-01-12',
						date8: '双休',
						date9: '偶尔加班',
						date10: '偶尔出差',
						date11: '预览职位',
					},
				],
				regLength: 0,

				// typeList: [{
				// 		value: '',
				// 		label: '精选双选会',
				// 	},
				// 	{
				// 		value: '1',
				// 		label: '线下双选会',
				// 	},
				// 	{
				// 		value: '2',
				// 		label: '空中双选会',
				// 	},
				// ],
				// job_type 招聘类型 1校招2实习3兼职
				// salary_min 薪资最小值   示例：5
				// salary_max 薪资最大值  示例：7
				// education 学历要求  json数组，格式如：["博士","本科"]
				// job_num 招聘人数   示例：2
				// end_time_st 截止时间开始  格式如2025-01-01
				// end_time_et 截止时间结束  格式如2025-01-01

				selectList: [],
				eduList: ['全部', '双一流', '本科', '高职高专'],
				freeList: ['不限', '是', '否'],
				isFree: '不限',
				isFreeMeeting: false,
				statusList: ['全部', '报名中', '进行中', '已结束'],
				salaryArry1: [],
				salaryArry2: [],
				salaryArry3: [],

				job_type: '', //招聘类型
				education: '', //学历要求

				meetingStatus: '', //双选会状态
				job_num: '', //招聘人数
				end_time_et: '', //截止时间
				salary_min: '',
				salary_max: '',

				isshow: false,
				salaryDisabled: true,
				qrcodeImg: '',

				loading: false,
				importData: false,

				searchObj: {},
				resmessage: '',

				dialogVisible1: false,
				serviceDetailVisible: false,
				qrcodeImg1: '',
				isnextPage: false,

				page: 1,

				selectMeetList: [],


				idList: [],

				num: 0,
				meetingALLPrice: 0,

				selectMeetList1: [],
				request: false,

				meeting_id: '',
				topMeeting: null,
				meetLinks: [],
				is_demo: 0,
				searchName1: '', 

				timer: null,


				isApply: true,



				checked: false,


				allChecked: false,


				selectMeetList1: [],

				meeting_num: 0,

				meeting_price: 0,
				selectIds: [],


				selectList1: [],
				isallshow:true,
				
				highlightIndex:0,
				
				showAll:false,
				noMoreMeetings: false,
				isLoadingMore: false,
				isMeetingInitializing: true,
				meetingRequestId: 0,
				meetid:null,
				line_name:null,
				showLine:true
			}
		},
		watch: {
			nextToken(val) {
				console.log(val)
				this.regLength = 0
			}
		},
		filters: {
			replaceDot(val){
				if(val){
					return val.replace('（','(').replace('）',')')
				}else{
					return val
				}
			},
			jobType(val) {
				switch (val) {
					case 1:
						return '全职'
					case 2:
						return '实习'
					case 3:
						return '兼职'
					default:
						return '全职'
				}
			},
			salary(val) {
				if (val) {
					return val
				} else {
					return '面议'
				}
			},
		},
		async mounted() {
			if (this.$route.query.demo == 2) {  
				sessionStorage.removeItem('demo')
				this.$router.replace({
					path: this.nextToken ? '/home' : '/login'
				})
				return
			}
			sessionStorage.removeItem('staffList')
			console.log(encodeURIComponent('湖南线路1'))
			localStorage.removeItem('addMeetJob')
			if (!this.nextToken) {
				sessionStorage.setItem('ismeet', 1)
			} else {
				sessionStorage.removeItem('ismeet')
			}
			const routeSmCode = this.$route.query.meetid ||this.$route.query.m_id || this.$route.query['amp;meetid'] || this.$route.query['amp;m_id']
			const routePhone = this.$route.query.phone||this.$route.query.s_id || this.$route.query['amp;phone']|| this.$route.query['amp;s_id']
			if (routeSmCode) {
				sessionStorage.setItem('smCode', routeSmCode)
			}
			if (routePhone) {
				sessionStorage.setItem('phone', routePhone)
			}
			const smCode = routeSmCode || sessionStorage.getItem('smCode')
			const phone = routePhone || sessionStorage.getItem('phone')
			if (smCode) {
				await this.getMeetingInfoBySmcode(smCode)
			}
			if (phone) {
				localStorage.setItem('salesmanPhone',phone)
				// this.meeting_id = this.$route.query.meetid
				// this.meeting_id = 3338
				// console.log(this.meeting_id)
			}
			if (this.$route.query.line_name ||this.$route.query.l_id) {
				this.line_name = decodeURIComponent(this.$route.query.l_id)
            
                if(this.line_name==577){
                    this.line_name= 578
                }
				// this.meeting_id = 3338
			}
			if(this.meeting_id==5524 && this.line_name==503){
                 localStorage.setItem('salesmanPhone',5524)
             }
			if(this.meeting_id==5547 && this.line_name==513){
                 localStorage.setItem('salesmanPhone',5547)
             }
			if (this.$route.query.demo) {
				this.is_demo = this.$route.query.demo
				sessionStorage.setItem('demo', this.$route.query.demo)
				if(this.is_demo==2 || this.is_demo==6){
					// this.meeting_id = 3326
				}else{
					this.showLine = false
					this.isApply = false
				}
			}else{
				sessionStorage.removeItem('demo')
				// this.showLine = false
				// this.isApply = true
			}
			if (sessionStorage.getItem('demo')) {
				// this.is_demo = sessionStorage.getItem('demo')
			}
			
			

			// 首屏主动加载，避免依赖无限滚动指令在旧浏览器或慢设备上的首次触发。
			// 若指令已先触发加载，则保持原请求，避免重复请求第一页。
			this.getmyJobList()
			this.isMeetingInitializing = false
			this.loadMeetLinks()
			this.getMySchoolMeeting()
			// this.getQrcode()
			let arr = [{
				label: '面议',
				value: 0,
			}, ]
			for (let i = 1; i < 31; i++) {
				arr.push({
					label: i + 'K',
					value: i,
				})
			}
			for (let i = 1; i < 15; i++) {
				arr.push({
					label: 30 + i * 5 + 'K',
					value: 30 + i * 5,
				})
			}
			for (let i = 1; i < 16; i++) {
				arr.push({
					label: 100 + i * 10 + 'K',
					value: 100 + i * 10,
				})
			}
			this.salaryArry1 = arr
			this.salaryArry2 = arr
			this.salaryArry3 = arr
            
            this.saveAccessLog('查看列表')
			// this.$util.post(
			// 	"/login/login", {
			// 		username: this.ruleForm.username,
			// 		password: this.$md5(this.ruleForm.pass),
			// 	},
			// 	(res) => {
			//
			// 		if (res.code == 1) {
			// 			localStorage.setItem("token", res.data.token);
			// 			this.$router.push({
			// 				path: "/main",
			// 				// query: {
			// 				//   id: 1,
			// 				// },
			// 			});
			// 		}
			// 	}
			// );
		},
		computed: {
			...mapState({
				nextToken: (state) => state.nextToken,
				userInfo: (state) => state.userInfo,
				schoolInfo: (state) => state.schoolData,
			}),
			selectedMeetingPaymentSummary() {
				const selectedMeetings = this.selectList1.filter((item) => item.isSelect)
				const platformMeetings = selectedMeetings.filter((item) => Number(item.meeting_status) === 1)
				const officialMeetings = selectedMeetings.filter((item) => Number(item.meeting_status) === 5)
				const platformPrice = platformMeetings.reduce((total, item) => {
					return total + (Number(item.meeting_price) || 0)
					// + (Number(item.stand_position_price) || 0)
				}, 0)

				return {
					platformCount: platformMeetings.length,
					officialCount: officialMeetings.length,
					platformPrice,
					hasPaidPlatform: platformPrice > 0,
					isAllPlatform: selectedMeetings.length > 0 && platformMeetings.length === selectedMeetings.length,
					isAllOfficial: selectedMeetings.length > 0 && officialMeetings.length === selectedMeetings.length
				}
			},
			selectedMeetingDisplayTotal() {
				return this.selectList1.filter((item) => item.isSelect).reduce((total, item) => {
					return total + (Number(item.meeting_price) || 0) + (Number(item.stand_position_price) || 0)
					// return total + (Number(item.meeting_price) || 0) + (Number(item.stand_position_price) || 0)-(Number(item.other_price) || 0)
				}, 0)
			},

			isNextPage() {
				// total
				// pageSizes
				// currentpage
				console.log(this.currentpage)
				console.log(Math.ceil(this.total / this.pageSizes))
				if (this.currentpage == Math.ceil(this.total / this.pageSizes) || Math.ceil(this.total / this.pageSizes) ==
					0) {
					return true
				} else {
					return false
				}
			}
		},
		methods: {
			...mapMutations(['setIslogin']),
			loadMeetLinks() {
				fetch('https://oss.sx985.com/2026/09/02/meetlink.json?_=' + Date.now())
					.then((response) => response.json())
					.then((response) => {
						this.meetLinks = Array.isArray(response.data) ? response.data : []
					})
					.catch(() => {
						this.meetLinks = []
					})
			},
			getMeetingLink(meeting) {
                // return
				const matchedLink = this.meetLinks.find((item) => {
					return item.academy_name === meeting.school_name && item.st_time && meeting.meeting_time && item.st_time.includes(meeting.meeting_time) 
				})
				return matchedLink || { link: 'https://mp.weixin.qq.com/s/hirK6yoxyeG9wsXi_kdOQw' }
			},
			openMeetingLink(meeting) {
				const matchedLink = this.getMeetingLink(meeting)
				if (matchedLink && matchedLink.link) {
					window.open(matchedLink.link, '_blank')
				}
			},
			getAnonymousId() {
				const storageKey = 'anonymous_id'
				let id = localStorage.getItem(storageKey)
				if (!id) {
					const hexChars = '0123456789abcdef'
					let randStr = ''
					for (let i = 0; i < 24; i++) {
						randStr += hexChars[Math.floor(Math.random() * 16)]
					}
					const tsHex = Date.now().toString(16)
					id = `anon_${tsHex}${randStr}`
					localStorage.setItem(storageKey, id)
				}
				return id
			},
			saveAccessLog(accessName) {
			
				this.$util.post('v2/school_job/saveAccessLog2', {
					admin_id: this.schoolInfo.admin_id || '',
					access_name: accessName,
					code: this.$route.query.phone || localStorage.getItem('salesmanPhone') || '',
					uuid: this.getAnonymousId()
				}, () => {}, () => {}, () => {})
			},
			getCoverTemplateIndex(id) {
				const numericId = Math.abs(Number(id))
				if (!Number.isFinite(numericId) || numericId <= 0) return 1
				const fixedTemplates = { 540511: 7, 540611: 11, 540711: 54, 540811: 16 }
                // const fixedTemplates = null
				if (fixedTemplates[numericId]) return fixedTemplates[numericId]
				const rawIndex = numericId % 70 || 70
				return ((rawIndex - 1) * 37 + 17) % 70 + 1
			},
			getCoverTemplateIndexByPosition(id) {
				return this.getCoverTemplateIndex(id)
			},
			getCoverBackgroundUrl(id, groupIndex, itemIndex) {
				const templateIndex = this.getCoverTemplateIndexByPosition(id, groupIndex, itemIndex)
				return `https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2026/07/01/bb${templateIndex}.png`
			},
			getSchoolNameSizeClass(schoolName) {
				const length = (schoolName || '').replace(/[\s（）()]/g, '').length
				if (length > 12) return 'two-line'
				if (length > 8) return 'small'
				if (length > 5) return 'medium'
				return 'large'
			},
			getSchoolNameLines(schoolName) {
				const name = schoolName || ''
				const length = name.replace(/[\s（）()]/g, '').length
				if (length <= 12) return [name]

				const firstLineLength = Math.floor((length - 2) / 2)
				let currentLength = 0
				let firstLine = ''
				let secondLine = ''
				let isSecondLine = false
				const nameParts = name.match(/（[^）]*）|\([^)]*\)|./g) || []

				nameParts.forEach((namePart) => {
					const partLength = namePart.replace(/[\s（）()]/g, '').length
					if (!isSecondLine && currentLength > 0 && currentLength + partLength > firstLineLength) {
						isSecondLine = true
					}
					if (isSecondLine) {
						secondLine += namePart
					} else {
						firstLine += namePart
					}
					if (!isSecondLine) currentLength += partLength
				})

				return [firstLine, secondLine]
			},
			getCoverTextColor(id, groupIndex, itemIndex) {
				const textColors = {
					1: '#7A4A00',
					2: '#14532D',
					3: '#0B3D91',
					4: '#9A3412',
					5: '#065F46',
					6: '#FFFFFF',
					7: '#FFFFFF',
					8: '#FFFFFF',
					9: '#831843',
					10: '#14532D',
					13: '#FFFFFF',
					18: '#166534',
					19: '#6D28D9',
					20: '#5B3217',
					21: '#7E1F4D',
					35: '#0090ff',
					36: 'blue',
					47: '#000000',
					49: '#000000',
					50: '#000000',
					52: '#FFFFFF',
					55: '#000000',
					56: '#000000',
					60: '#000000',
					61: '#FFFFFF',
					66: '#FFFFFF',
					68: '#000000',
					69: '#000000'
				}
				const templateIndex = this.getCoverTemplateIndexByPosition(id, groupIndex, itemIndex)
				if (textColors[templateIndex]) return textColors[templateIndex]
				if (templateIndex >= 31) return '#FFFFFF'
				if (templateIndex >= 11) return '#704A09'
				return '#000000'
			},
			handleCoverImageError(event) {
				event.target.style.display = 'none'
			},
			load(){
				if (this.loading || this.isLoadingMore || this.noMoreMeetings) return
				if (this.meetlist.length > 0) {
					this.currentpage++
				}
				this.getmyJobList(this.meetlist.length === 0)
			},
			toshowItems(){
				this.showAll = false
				this.meetlist[0].list.forEach((item,index,arr)=>{
					if(item.isshow){
						if(item.isshow==1){
							arr[index].isshow = 2
						}else{
							arr[index].isshow = 1
						}
					}
				})
				console.log(this.meetlist[0].list)
			},
			corporateApply() {
				if (!this.nextToken) {
					this.$confirm('使用完整功能，请登录使用！', '提示', {
						confirmButtonText: '去登录',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						this.$router.push({
							path: '/login',
							// query: {
							//   id: 1,
							// },
						})
					}).catch(() => {

					});
					return
				}
				this.$router.push({
					path: '/corporateApply',
				})
			},
			// 二维数组展开
			flatTree(arr) {
				const groupRecord = [] // 记录每组子数组长度
				const flatItems = []
				arr.forEach(item => {
					const len = item.list.length
					groupRecord.push(len)
					flatItems.push(...item.list)
				})
				return {
					flatItems,
					groupRecord
				}
			},
			async signAll1() {
			
				if (await this.isDebounce()) return;
				if (!this.nextToken) {
					this.$confirm('使用完整功能，请登录使用！', '提示', {
						confirmButtonText: '去登录',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						this.$router.push({
							path: '/login',
							// query: {
							//   id: 1,
							// },
						})
					}).catch(() => {

					});
					return
				}
				const {
					flatItems,
					groupRecord
				} = this.flatTree(this.meetlist)
				let mySchoolMeeting = await this.getMySchoolMeeting()
				let idList = []

				mySchoolMeeting.forEach((item, index, arr) => {
					idList.push(item.id)
				})

				let selectMeetList = this.selectList1.filter((item) => this.canSelect(item))

				let meetingIdList = []
				let meeting_price = 0
				let stand_position_price = 0
				let allNameList = []
				let isOther = true
				selectMeetList.forEach((item, index, arr) => {
					meeting_price += Number(item.meeting_price) || 0
					stand_position_price += Number(item.stand_position_price) || 0
					// meeting_price += Number(item.stand_position_price) || 0
					allNameList.push(item.meeting_name)
					isOther = false
					meetingIdList.push(item.id)
				})
				if (meetingIdList.length == 0) {
					this.$message({
						message: '暂未选择双选会',
						type: 'error',
					})
					return
				}
				if (meetingIdList.length < 1) {
					this.$message({
						message: '线路报名至少需选择一场 ',
						type: 'error',
					})
					return
				}
				let obj = {
					meetId: meetingIdList,
					meeting_address: '',
					pdf_url: '',
					meeting_name: '线路报名' + allNameList.length + '场双选会，（' + allNameList.join('，') + '）',
					sign_time: '',
					meeting_price: meeting_price,
					stand_position_price: stand_position_price,
					meeting_cat: selectMeetList.some((item) => Number(item.meeting_cat) === 1) ? 1 : 2,
					isBatch: true,
					isOther: isOther
				}
				console.log(obj)
				sessionStorage.setItem('meetObj', JSON.stringify(obj))
				sessionStorage.setItem('selectMeetList', JSON.stringify(this.sortMeetListForSignup(selectMeetList)))
				this.$router.push({
					path: '/signup',
					// query: {
					//   id: 1,
					// },
				})
                
                this.saveAccessLog('点击去报名')
			},
			getSelectNum() {
				const {
					flatItems,
					groupRecord
				} = this.flatTree(this.meetlist)
				this.selectMeetList1 = flatItems.filter((item, index, arr) => {
					return item.isSelect == true
				})

				// const currIdList = flatItems.map(v => v.id);
				flatItems.forEach(row => {
					const idx = this.selectIds.indexOf(row.id);
					if (row.isSelect) {
						if (idx === -1) {
							this.selectList1.push({
								...row
							});
							this.selectIds.push(row.id);
						}
					} else {
						if (idx > -1) {
							this.selectList1.splice(idx, 1);
							this.selectIds.splice(idx, 1);
						}
					}
				});

				let meeting_price = 0
				let meeting_num = 0
				this.selectList1.forEach((item, index, arr) => {
					if (item.isSelect) {
						meeting_price += Number(item.meeting_price)
						// meeting_price += Number(item.stand_position_price)
						meeting_num++
					}
				})
				this.meeting_num = meeting_num
				this.meeting_price = meeting_price
			},
			toggleMeetingSelection(item, index, itm, idx) {
				if (this.selectable1(itm, idx)) return
				this.meetlist[index].list[idx].isSelect = !this.meetlist[index].list[idx].isSelect
				this.itemSelect(item, index, itm, idx)
			},
			itemSelect(item, index, itm, idx) {
				if (!this.nextToken) {
					this.meetlist[index].list[idx].isSelect = false
					this.$confirm('使用完整功能，请登录使用！', '提示', {
						confirmButtonText: '去登录',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						this.$router.push({
							path: '/login',
							// query: {
							//   id: 1,
							// },
						})
					}).catch(() => {

					});
					return
				}

				let isSelect = true
				this.meetlist[index].list.forEach((itm, idx, array) => {
					if (this.canSelect(itm)) {
						if (!itm.isSelect) {
							isSelect = false
						}
					}
				})
				this.meetlist[index].isSelect = isSelect
				this.getSelectNum()
				if (itm.isSelect) {
					this.saveAccessLog('选择' + (itm.meeting_name || '') + '双选会')
				}
			},
			someSelect(index, item) {
				if (!this.nextToken) {
					this.meetlist[index].isSelect = false
					this.meetlist[index].list.forEach((itm, idx, array) => {
						itm.isSelect = false
					})
					this.$confirm('使用完整功能，请登录使用！', '提示', {
						confirmButtonText: '去登录',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						this.$router.push({
							path: '/login',
							// query: {
							//   id: 1,
							// },
						})
					}).catch(() => {

					});
					return
				}

				if (this.meetlist[index].isSelect) {
					this.meetlist[index].list.forEach((itm, idx, array) => {
						if (this.canSelect(itm)) {
							itm.isSelect = true
						}
					})
				} else {
					this.meetlist[index].list.forEach((itm, idx, array) => {
						itm.isSelect = false
					})
				}
				this.getSelectNum()
			},
			allSelect() {
				if (this.allChecked) {
					this.meetlist.forEach((item, index, arr) => {
						item.list.forEach((itm, idx, array) => {
							if (this.canSelect(itm)) {
								itm.isSelect = true
								item.isSelect = true
							}
						})
					})
				} else {
					this.meetlist.forEach((item, index, arr) => {
						item.list.forEach((itm, idx, array) => {
							itm.isSelect = false
							item.isSelect = false
						})
					})
				}
				this.getSelectNum()
			},
			selectable2(item, index) {
				let boolean = true
				item.list.forEach((item, index, arr) => {
					if (this.canSelect(item)) {
						boolean = false
					}
				})
				return boolean
			},
			selectable1(row, index) {
				return !this.canSelect(row)
			},
			isRegistered(meeting) {
				return Number(meeting.reg_status) === 1
			},
			canSelect(meeting) {
				return !this.isRegistered(meeting) && (Number(meeting.meeting_status) === 1 || Number(meeting.meeting_status) === 5)
			},
			sortMeetListForSignup(meetList) {
				return meetList.map((item, index) => ({
					item,
					index,
					hasMeetingPrice: item.meeting_price && Number(item.meeting_price) !== 0,
				})).sort((a, b) => {
					return Number(b.hasMeetingPrice) - Number(a.hasMeetingPrice) || a.index - b.index
				}).map((item) => item.item)
			},

			toJobShadowing() {
				if (!this.nextToken) {
					this.$confirm('使用完整功能，请登录使用！', '提示', {
						confirmButtonText: '去登录',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						this.$router.push({
							path: '/login',
							// query: {
							//   id: 1,
							// },
						})
					}).catch(() => {

					});
					return
				}
				this.$router.push({
					path: '/jobShadowing',
				})
			},
			toWednesday() {
				if (!this.nextToken) {
					this.$confirm('使用完整功能，请登录使用！', '提示', {
						confirmButtonText: '去登录',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						this.$router.push({
							path: '/login',
							// query: {
							//   id: 1,
							// },
						})
					}).catch(() => {

					});
					return
				}
				this.$router.push({
					path: '/wednesday',
				})
			},
			toCooperation() {
				if (!this.nextToken) {
					this.$confirm('使用完整功能，请登录使用！', '提示', {
						confirmButtonText: '去登录',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						this.$router.push({
							path: '/login',
							// query: {
							//   id: 1,
							// },
						})
					}).catch(() => {

					});
					return
				}
				this.$router.push({
					path: '/cooperation',
				})
			},
			applyChange(val) {
				if (!this.nextToken) {
					this.isApply = true
					this.$confirm('使用完整功能，请登录使用！', '提示', {
						confirmButtonText: '去登录',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						this.$router.push({
							path: '/login',
							// query: {
							//   id: 1,
							// },
						})
					}).catch(() => {

					});
					return
				}

				console.log(val)
				if (val) {
					this.gradation.forEach((item, index, arr) => {
						item.isSelect = false
					})
					this.gradation[0].isSelect = true
				}
				this.currentpage = 1
				this.meetlist = []
				this.getmyJobList()
			},
			handleSizeChange(val) {
				this.pageSizes = val
				this.currentpage = 1
				this.meetlist = []
				this.getmyJobList()
			},
			onLine() {

				// this.dialogVisible = true
				this.handleQrcode()
			},
			handleQrcode(row) {
				// if (!this.nextToken) {
				// 	this.$confirm('使用完整功能，请登录使用！', '提示', {
				// 		confirmButtonText: '去登录',
				// 		cancelButtonText: '取消',
				// 		type: 'warning'
				// 	}).then(() => {
				// 		this.$router.push({
				// 			path: '/login',
				// 			// query: {
				// 			//   id: 1,
				// 			// },
				// 		})
				// 	}).catch(() => {

				// 	});
				// 	return
				// }
				// this.getQrcode(row.admin_id)
				this.dialogVisible = true
				// &is_test=1
				this.$util.post(
					`admin/home/qrcode?app_type=10&not_login=1&page_path=pages/courseware/meeting&id=${row.id}&is_test=${config.IS_TEST}`, {

					},
					(res) => {
						if (res.code == 200) {
							this.qrcodeImg = res.data.qrCode
							// this.sceneId = res.data.scene
							// this.setTimer()
							// localStorage.setItem('qrcodeImg', res.data.qrCode)
						}
					}
				)
			},
			offline(row) {
				if (row.stand_position_url) {
					window.open(row.stand_position_url, '_blank')
				}
			},
			// 防抖处理
			isRequest(duration = 3000) {
				if (this.request) return true
				this.request = true
				setTimeout(() => {
					this.request = false
				}, duration)
				return false
			},
			selectProvince(index) {
				this.currentpage = 1
				if (index == 0) {
					this.majors.forEach((item, index, arr) => {
						item.isSelect = false
					})
					this.majors[0].isSelect = true
				} else {
					this.majors[0].isSelect = false
					this.majors[index].isSelect = !this.majors[index].isSelect
					let bol = false
					this.majors.forEach((item, index, arr) => {
						if (item.isSelect == true) {
							bol = true
						}
					})
					if (!bol) {
						this.majors[0].isSelect = true
					}
				}
				if (this.searchName == '') {
					this.searchName1 = ''
				}
				this.currentpage = 1
				this.meetlist = []
				this.getmyJobList()
			},

			async selectgradation(index) {
				if (await this.isDebounce()) return;
				this.currentpage = 1
				if (index == 0) {
					this.gradation.forEach((item, index, arr) => {
						item.isSelect = false
					})
					this.gradation[0].isSelect = true
					this.isFreeMeeting = false
				} else {
					this.gradation[0].isSelect = false
					this.gradation[index].isSelect = !this.gradation[index].isSelect
				}

				let bol = false
				this.gradation.forEach((item, index, arr) => {
					if (item.isSelect == true) {
						bol = true
					}
				})
				if (!bol && !this.isFreeMeeting) {
					this.gradation[0].isSelect = true
				}
				if (this.searchName == '') {
					this.searchName1 = ''
				}
				this.currentpage = 1
				this.meetlist = []
				this.getmyJobList()
			},
			selectFreeMeeting() {
				this.isFreeMeeting = !this.isFreeMeeting
				if (this.isFreeMeeting) {
					this.gradation[0].isSelect = false
				} else if (!this.gradation.slice(1).some((item) => item.isSelect)) {
					this.gradation[0].isSelect = true
				}
				this.currentpage = 1
				this.meetlist = []
				this.getmyJobList()
			},


			selecttypeList(index) {
				this.typeList.forEach((item, index, arr) => {
					item.isSelect = false
				})
				this.typeList[index].isSelect = true
			},
			selectexpense(index) {
				this.expense.forEach((item, index, arr) => {
					item.isSelect = false
				})
				this.expense[index].isSelect = true
			},

			tableRowClassName({
				row,
				rowIndex
			}) {
				if (row.id == this.meeting_id) {
					console.log(row)
					console.log(rowIndex)
					return 'warning-row';
				}
			},
			selectable(row, index) {
				if ((row.meeting_status == 1 || row.meeting_status == 6) && !this.idList.includes(row.id)) {
					return true
				} else {
					return false
				}

			},
			towebsite(row) {
				console.log(row)
				if (row.meeting_status == 5) {
					if (!row.website || row.website == '暂未公布') {
						this.$message.warning('暂未公布官网报名链接！');
					} else {
						window.open(row.website)
					}
				}

			},

			towebsite1() {
				if (row.meeting_status == 6) {
					if (!row.website || row.website == '暂未公布') {
						this.$message.warning('暂无缴费链接！');
					} else {
						window.open(row.website)
					}
				}
			},
			handleClick1(row) {

				if (!this.nextToken) {
					this.$confirm('使用完整功能，请登录使用！', '提示', {
						confirmButtonText: '去登录',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						this.$router.push({
							path: '/login',
							// query: {
							//   id: 1,
							// },
						})
					}).catch(() => {

					});
					return
				}

				console.log(row)
				this.getQrcode1(row.id, row)
				this.dialogVisible1 = true
				// this.$router.push({
				// 	path: "/jobDetails",
				// 	// query: {
				// 	//   id: 1,
				// 	// },
				// });
			},
			getQrcode1(id, scope) {
				// &is_test=1
				this.$util.post(
					`admin/home/qrcode?app_type=10&not_login=1&page_path=pages/courseware/meeting&id=${id}&is_test=${config.IS_TEST}`, {
						// app_type: 10,
						// page_path: 'pages/recruit/jobdetail',
						// id:id
					},
					(res) => {
						if (res.code == 200) {
							this.qrcodeImg1 = res.data.qrCode

							// this.sceneId = res.data.scene
							// this.setTimer()
							// localStorage.setItem('qrcodeImg', res.data.qrCode)
						}
					}
				)
			},
			closeElDialog1() {
				this.dialogVisible1 = false
			},
			beforeUpload() {},
			handleAvatarSuccess1(res, file) {
				console.log(res)
				if (res.code == 200) {
					this.resmessage = res.data
					this.$message({
						message: '上传成功',
						type: 'success',
					})
				} else {
					this.$message({
						showClose: true,
						message: file.response.msg,
						type: 'error',
					})
				}
			},
			addEnterprise() {
				this.importData = true
			},
			download1() {
				location.href = 'https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2025/06/18/obrfctzaoq3jiiqz.xlsx'
			},
			reset() {
				this.job_type = ''
				this.job_num = ''
				this.salary_min = ''
				this.salary_max = ''
				this.education = ''

				this.searchObj = {}
				this.currentpage = 1
				this.meetlist = []
				this.getmyJobList()
			},
			setJobNum(val) {
				if (val == '') {
					this.job_num = ''
				} else if (val < 1) {
					this.job_num = 1
				}
			},
			getQrcode(id) {
				// &is_test=1 
				this.$util.post(
					`admin/home/qrcode?app_type=10&not_login=1&page_path=pages/recruit/jobdetail&id=${id}&is_test=${config.IS_TEST}`, {
						// app_type: 10,
						// page_path: 'pages/recruit/jobdetail',
						// id:id
					},
					(res) => {
						if (res.code == 200) {
							this.qrcodeImg = res.data.qrCode
							// this.sceneId = res.data.scene
							// this.setTimer()
							// localStorage.setItem('qrcodeImg', res.data.qrCode)
						}
					}
				)
			},
			selectAll(selection) {
				console.log(selection)
				let selectMeetList = JSON.parse(JSON.stringify(this.selectMeetList))
				if (selection.length > 0) {

					const ids = selectMeetList.map(item => item.id);
					selection.forEach((item, index, arr) => {
						if (!ids.includes(item.id)) {
							selectMeetList.push(item)
						}
					})

				} else {
					const ids = this.meetlist.map(item => item.id);
					selectMeetList = selectMeetList.filter(item => {
						return !ids.includes(item.id);
					});
				}
				console.log(selectMeetList)
				this.selectMeetList = selectMeetList
			},


			handleSelectionChange(selection, row) {
				let selectIndex = -1
				let selectMeetList = JSON.parse(JSON.stringify(this.selectMeetList))
				selectMeetList.forEach((item, index, arr) => {
					if (item.id == row.id) {
						selectIndex = index
					}
				})
				if (selectIndex == -1) {
					selectMeetList.push(row)
				} else {
					selectMeetList.splice(selectIndex, 1)
				}
				this.selectMeetList = selectMeetList
				// this.selectMeetList = val
				// let selectMeetList = this.selectMeetList.filter((item, index, arr) => {
				// 	return item.meeting_status == 1 && !this.idList.includes(item.id)
				// })
				// let meetingIdList = []
				// let meeting_price = 0
				// selectMeetList.forEach((item, index, arr) => {
				// 	meeting_price += Number(item.meeting_price)
				// 	meetingIdList.push(item.id)
				// })

				// this.num = meetingIdList.length
				// this.meetingALLPrice = meeting_price
			},

			changeSalay1(val) {
				this.salary_max = ''
				if (val == 0) {
					this.isshow = false
				} else {
					this.isshow = true
				}
				let arr = []
				let array = JSON.parse(JSON.stringify(this.salaryArry3))
				arr = array.filter((item) => {
					return item.value > val
				})
				this.salaryDisabled = false
				this.salaryArry2 = arr
			},
			cancel() {
				this.dialogVisibleMultipleChoice4 = false
			},
			multiple4(val) {
				console.log(val)
				if (val.length > 0) {
					this.province_name = val.toString()
				} else {
					this.province_name = ''
				}

				this.dialogVisibleMultipleChoice4 = false
				this.academy_feature = val
				this.currentpage = 1
				this.meetlist = []
				this.getmyJobList()
				// this.getUserRecordList()
			},


			multipleClose() {
				this.multipleChange = false
			},
			searchWord(val) {
				this.college_type_list = val
			},
			handleClose(done) {
				done()
			},
			multipleOpen() {
				this.multipleChange = true
			},

			search() {
				// job_num
				// if(this.job_num>10000)
				let obj = {
					job_type: this.job_type,
					job_num: this.job_num,
				}
				if (this.salary_min == 0) {
					obj.salary_min = 0
					obj.salary_max = 0
				} else {
					obj.salary_min = this.salary_min
					obj.salary_max = this.salary_max
				}
				if (this.education !== '') {
					obj.education = JSON.stringify(this.education)
				}

				this.searchObj = obj
				this.searchName1 = this.searchName
				this.currentpage = 1
				this.meetlist = []
				this.getmyJobList()
				// this.$message({
				// 	message: '加载成功',
				// 	type: 'success'
				// });
			},
			resetSearch() {
				this.searchName = ''
				this.searchName1 = ''
				this.majors.forEach((item, index) => {
					item.isSelect = index === 0
				})
				this.gradation.forEach((item, index) => {
					item.isSelect = index === 0
				})
				this.isFreeMeeting = false
				this.currentpage = 1
				this.meetlist = []
				this.getmyJobList()
			},
			selectcityBox3() {
				this.dialogVisibleMultipleChoice4 = true
			},
			changeMeeting(val) {
				// this.headIndex = val
				this.currentpage = 1
				this.meetlist = []
				this.getmyJobList()
				console.log('val', val)
			},
			changeIsFree(val) {
				console.log(val)
				this.currentpage = 1
				this.meetlist = []
				this.getmyJobList()
			},
			changeMeetingLevel(val) {
				console.log(val)
				// this.headIndex = val
				// this.getmyJobList()

				if (val === '全部') {
					this.shcool_level = ''
				} else {
					this.shcool_level = JSON.stringify([val])
				}
				this.currentpage = 1
				this.meetlist = []
				this.getmyJobList()
				console.log('val', val)
			},
			changeMeetingStatus() {
				this.currentpage = 1
				this.meetlist = []
				this.getmyJobList()
			},
			getDaysUntilNextYear(days) {
				const now = new Date() // 当前日期和时间
				const standardStr = days.replace('年', '/').replace('月', '/').replace('日', '')
				const nextYear = new Date(standardStr) // 明年的同一天
				const diffTime = nextYear.getTime() - now.getTime() // 获取两个日期的毫秒差
				const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)) // 将毫秒转换为天数
				return diffDays
			},
			// load() {
			// 	this.currentpage += 1
			// 	console.log(789451)
			// },

			getMeetingInfoBySmcode(smCode) {
				return new Promise((resolve) => {
					this.$util.post('v2/school_job/getMeetingInfoBySmcode', {
						sm_code: smCode
					}, (res) => {
						if (res.code === 0 && res.data) {
							this.meeting_id = res.data.meeting_id || ''
							this.topMeeting = res.data.meeting || null
						} else if (res.code === 0) {
							this.meeting_id = smCode
						}
						resolve()
					}, resolve)
				})
			},
			shouldShowTopMeeting(searchName, provinceNames, schoolTypes) {
				if (!this.topMeeting) return false
				if (provinceNames.length && !provinceNames.includes(this.topMeeting.province_name)) return false
				if (schoolTypes.length && !schoolTypes.includes(this.topMeeting.school_type)) return false
				return !searchName || (this.topMeeting.meeting_name || '').includes(searchName) || (this.topMeeting.school_name || '').includes(searchName)
			},
			shouldCollapseLine(item, provinceNames) {
				if (!item.list || item.list.length <= 10) return false
				if (provinceNames.length !== 1) return true
				return !item.list.some((itm) => itm.province_name == provinceNames[0])
			},
			expandLine(item) {
				item.isLineCollapsed = false
			},
			getmyJobList(showLoading = true) {
				this.loading = showLoading
				this.isLoadingMore = !showLoading
				if (showLoading) {
					this.noMoreMeetings = false
				}
				const requestId = ++this.meetingRequestId
				let searchName = this.searchName1.replace(/%/g, '');
				let selectMeetList = []
				if (this.selectMeetList.length > 0) {
					selectMeetList = JSON.parse(JSON.stringify(this.selectMeetList))
				}

				console.log('shcool_level', this.shcool_level)
				let meetingStatus = -1
				if (this.meetingStatus == '报名中') {
					meetingStatus = 1
				} else if (this.meetingStatus == '进行中') {
					meetingStatus = 1
				} else if (this.meetingStatus == '已结束') {
					meetingStatus = -1
				}

				let province_name = []
				this.majors.forEach((item, index, arr) => {
					if (item.isSelect) {
						if (item.name == '全部') {
							province_name = []
						} else {
							province_name.push(item.name)
						}
					}
				})

				let school_type = []
				this.gradation.forEach((item, index, arr) => {
					if (item.isSelect) {
						if (item.name == '全部') {
							school_type = []
						} else {
							school_type.push(item.name)
						}
					}
				})
				let obj = {
					page: this.currentpage,
					province_name_arr: JSON.stringify(province_name) || '',
					school_type: JSON.stringify(school_type) || '',
					meeting_name: searchName,
					meeting_status: meetingStatus,
					size: 5,
					// meeting_id: this.meeting_id,
					meeting_id:this.meeting_id,
					admin_id: this.schoolInfo.admin_id,
					reg_status: -1,
					is_charge: this.isFreeMeeting ? 0 : -1,
					meeting_cat: -1,
					// line:this.line_name,
					// is_demo: 2
					adv_pos:'pro'  //pro
				}
                console.log('this.is_demo',this.is_demo)
                if(this.is_demo==5){
                    obj.adv_pos = 'out_5'
                }
                if(this.is_demo==6){
                    obj.adv_pos = 'test'
                }
                
				// if (this.is_demo) {
				// 	obj.is_demo = this.is_demo
				// }else{
				// 	obj.is_demo = 2
				// 	// this.showLine = true
				// 	// this.isApply = true
				// }
				// else {
				// 	obj.is_demo = 1
				// }
				if (this.isFree == '不限') {

				} else if (this.isFree == '是') {
					obj.is_charge = 1
				} else {
					obj.is_charge = 0
				}
				if (this.headIndex) {
					obj.meeting_cat = this.headIndex
				}
				console.log('shcool_level', this.shcool_level)
				let that = this
				this.$util.get('v2/getMeetListByLineToB2', obj, async (res) => {
					if (requestId !== this.meetingRequestId) return
					if (res.code === 200) {
						// if (this.page == 1) {
						console.log(res.data)
						let meetlist = Array.isArray(res.data.data) ? res.data.data : []
						if (searchName) {
							meetlist.forEach((item) => {
								item.list = (item.list || []).filter((itm) => (itm.meeting_name || '').includes(searchName) || (itm.school_name || '').includes(searchName))
							})
							meetlist = meetlist.filter((item) => item.list.length > 0)
						}
						if (this.currentpage == 1 && this.shouldShowTopMeeting(searchName, province_name, school_type)) {
							meetlist.forEach((item) => {
								item.list = (item.list || []).filter((itm) => itm.id != this.topMeeting.id)
							})
							meetlist = meetlist.filter((item) => item.list.length > 0)
							meetlist.unshift({
								line: this.topMeeting.line,
								line_name: this.topMeeting.line_name,
								isTopMeeting: true,
								isSelect: false,
								list: [{
									...this.topMeeting,
									isSelect: false
								}]
							})
						}
						meetlist.forEach((item) => {
							item.isLineCollapsed = this.shouldCollapseLine(item, province_name)
						})
						if (meetlist.length > 0) {
							meetlist.forEach((item, index, arr) => {
								arr[index].isSelect = false
								item.list.forEach((itm, idx, array) => {
									array[idx].isSelect = false
									// if('北京大学清华大学'.indexOf(itm.school_name)>-1){
									// 	itm.other_price = 800
									// }else{
									// 	itm.other_price = 0
									// }
									itm.other_price = 0
									if (itm.reg_end_time) {
										itm.sDay = that.getDaysUntilNextYear('2026年' + itm
											.reg_end_time)
									} else {
										itm.sDay = that.getDaysUntilNextYear('2026年' + itm
											.meeting_time)
									}
									
								})
							})

							meetlist.forEach((item, index, arr) => {
								let isSelect = true
								item.list.forEach((itm, idx, array) => {
									const selectedIndex = this.selectIds.indexOf(itm.id)
									if (selectedIndex > -1 && this.canSelect(itm)) {
										array[idx].isSelect = true
									} else if (selectedIndex > -1) {
										this.selectIds.splice(selectedIndex, 1)
										this.selectList1.splice(selectedIndex, 1)
									}
									
									console.log(!this.idList.includes(itm.id))
									console.log(!itm.isSelect)
									
									if (this.canSelect(itm)) {
										if (!itm.isSelect) {
											isSelect = false
										}
									}
								})
								item.isSelect = isSelect
							})
							
							if (this.meeting_id&&this.currentpage==1) {
								let highlightList = JSON.parse(JSON.stringify(meetlist[0]))
								let highlightIndex = 0
								meetlist[0].list.forEach((item, index, arr) => {
									if (item.id == this.meeting_id) {
										highlightIndex = index
									}
								})
								if(highlightIndex>3){
									this.showAll = true
									meetlist[0].isLineCollapsed = false
									meetlist[0].list.forEach((item, index, arr) => {
										if (index!=0&&index<highlightIndex) {
											arr[index].isshow = 1
										}
									})
								}
								this.highlightIndex = highlightIndex
							}
							
							this.meetlist = [...this.meetlist,...meetlist]
							const pageMeta = res.data.meta || {}
							const currentPage = Number(pageMeta.current_page || res.data.current_page)
							const lastPage = Number(pageMeta.last_page || res.data.last_page)
							if (lastPage && currentPage >= lastPage) {
								this.noMoreMeetings = true
							}
							this.getSelectNum()
							this.loading = false
							this.isLoadingMore = false
							// let mySchoolMeeting = await that.getMySchoolMeeting()
							// let idList = []
							// mySchoolMeeting.forEach((item, index, arr) => {
							// 	idList.push(item.id)
							// })
							// this.idList = idList
							// // this.idList = [3583, 3312, 3333, 3334, 3332, 3329, 3330, 3328, 3271, 3266, 3268, 3324,3326,3327,3331]
							// meetlist.forEach((item,index,arr)=>{
							// 	item.list.forEach((itm,idx,array)=>{
							// 		if (idList.includes(itm.id)) {
							// 			array[idx].registered = true
							// 		}else{
							// 			array[idx].registered = false
							// 		}
							// 	})
							// })

							// that.meetlist = meetlist

						} else {
							this.isnextPage = false
							this.noMoreMeetings = true
							// this.meetlist = []
						}
						this.loading = false
						this.isLoadingMore = false

						return

						// if (res.data.data.length > 0) {
						// 	console.log('res.data.data', 11111111111111)
						// 	res.data.data.forEach((item) => {
						// 		if (item.reg_end_time) {
						// 			item.sDay = that.getDaysUntilNextYear('2026-' + item.reg_end_time)
						// 		} else {
						// 			item.sDay = that.getDaysUntilNextYear('2026-' + item.meeting_time)
						// 		}
						// 		// item.meeting_status = '1'
						// 	})


						// 	this.meetlist = res.data.data
						// 	this.loading = false

						// 	let mySchoolMeeting = await that.getMySchoolMeeting()
						// 	let meetlist = res.data.data
						// 	console.log(mySchoolMeeting)
						// 	let idList = []
						// 	mySchoolMeeting.forEach((item, index, arr) => {
						// 		idList.push(item.id)
						// 	})

						// 	this.idList = idList
						// 	meetlist.forEach((item, index, arr) => {
						// 		if (idList.includes(item.id)) {
						// 			arr[index].registered = true
						// 		}
						// 	})
						// 	// meetlist[0].meeting_status = 5

						// 	// let meetlist1 = []
						// 	// if (this.shcool_level) {
						// 	// 	meetlist1 = meetlist.filter((item) => {
						// 	// 		return this.shcool_level.indexOf(item.school_type) > -1
						// 	// 	})
						// 	// } else {
						// 	// 	meetlist1 = meetlist
						// 	// }
						// 	this.meetlist = meetlist1

						// 	this.$nextTick(() => {
						// 		if (this.selectMeetList.length > 0) {
						// 			// meetlist1.
						// 			// selectMeetList
						// 			let selectMeetIds = []
						// 			selectMeetList.forEach((item, index, arr) => {
						// 				selectMeetIds.push(item.id)
						// 			})

						// 			console.log(selectMeetIds)
						// 			meetlist1.forEach((item, index, arr) => {
						// 				if (selectMeetIds.includes(item.id)) {
						// 					console.log(item)
						// 					this.$refs.multipleTable.toggleRowSelection(item);
						// 				}
						// 			})
						// 		}
						// 	})

						// } else {
						// 	this.isnextPage = false
						// 	this.meetlist = []
						// }
					} else {
						this.isnextPage = false
						this.noMoreMeetings = true
					}
					this.total = res.data.total

				}, (err) => {
					if (requestId !== this.meetingRequestId) return
					console.log(err)
					if (!showLoading && this.currentpage > 1) {
						this.currentpage--
					}
					this.loading = false
					this.isLoadingMore = false
				})
			},


			$getTime(symbol = '-', status = 0, time = Date.now()) {
				let date = new Date(time)
				let Y = date.getFullYear() + symbol

				let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + symbol
				let D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' '

				let H = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
				let Minu = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':'
				let S = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
				switch (status) {
					case 0:
						return Y + M + D
					case 1:
						return Y + M + D + H + Minu + S
					default:
						break
				}
			},
			getTime(dateTimeString) {
				const dateTime = new Date(dateTimeString)
				const year = dateTime.getUTCFullYear()
				const month = String(dateTime.getUTCMonth() + 1).padStart(2, '0')
				const day = String(dateTime.getUTCDate()).padStart(2, '0')
				// const hour = String(dateTime.getUTCHours()).padStart(2, '0');
				// const minute = String(dateTime.getUTCMinutes()).padStart(2, '0');
				// const second = String(dateTime.getUTCSeconds()).padStart(2, '0');

				const formattedDateTime = `${year}-${month}-${day}`

				return formattedDateTime
			},
			isRequest(duration = 2000) {
				if (this.request) return true
				this.request = true
				setTimeout(() => {
					this.request = false
				}, duration)
				return false
			},
			postPosition() {
				if (!this.nextToken) {
					this.$confirm('使用完整功能，请登录使用！', '提示', {
						confirmButtonText: '去登录',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						this.$router.push({
							path: '/login',
							// query: {
							//   id: 1,
							// },
						})
					}).catch(() => {

					});
					return
				}
				this.$router.push({
					path: '/reglist',
					// query: {
					//   id: 1,
					// },
				})
			},
			isDebounce(duration = 500) {
				return new Promise(resolve => {
					// 如果已有定时器，清除（重新计时）
					if (this.timer) {
						clearTimeout(this.timer);
					}
					// 开启新定时器
					this.timer = setTimeout(() => {
						resolve(); // 时间到 → 放行
					}, duration);
				});
			},
			async signAll() {
				if (await this.isDebounce()) return;
				if (!this.nextToken) {
					this.$confirm('使用完整功能，请登录使用！', '提示', {
						confirmButtonText: '去登录',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						this.$router.push({
							path: '/login',
							// query: {
							//   id: 1,
							// },
						})
					}).catch(() => {

					});
					return
				}
				if (this.isRequest()) return false
				let mySchoolMeeting = await this.getMySchoolMeeting()
				let idList = []

				mySchoolMeeting.forEach((item, index, arr) => {
					idList.push(item.id)
				})
				let selectMeetList = this.selectList1.filter((item, index, arr) => {
					return this.canSelect(item)
				})
				console.log(selectMeetList)
				let meetingIdList = []
				let meeting_price = 0
				let allNameList = []
				let isOther = true
				selectMeetList.forEach((item, index, arr) => {
					meeting_price += Number(item.meeting_price) || 0
					// meeting_price += Number(item.stand_position_price) || 0
					allNameList.push(item.meeting_name)
					isOther = false
					meetingIdList.push(item.id)
				})
				// if (meetingIdList.length == 0) {
				// 	this.$message({
				// 		message: '暂未选择双选会',
				// 		type: 'error',
				// 	})
				// 	return
				// }
				if (meetingIdList.length == 0) {
					this.$message({
						message: '报名至少需要选择一场 ',
						type: 'error',
					})
					return
				}
				let obj = {
					meetId: meetingIdList,
					meeting_address: '',
					pdf_url: '',
					meeting_name: '线路报名' + allNameList.length + '场双选会，（' + allNameList.join('，') + '）',
					sign_time: '',
					meeting_price: meeting_price,
					meeting_cat: selectMeetList.some((item) => Number(item.meeting_cat) === 1) ? 1 : 2,
					isBatch: true,
					isOther: isOther
				}
				console.log(obj)
				sessionStorage.setItem('meetObj', JSON.stringify(obj))
				sessionStorage.setItem('selectMeetList', JSON.stringify(this.sortMeetListForSignup(selectMeetList)))
				this.$router.push({
					path: '/signup',
					// query: {
					//   id: 1,
					// },
				})
			},
			toSign(scope) {
				if (this.isRegistered(scope)) return

				if (!this.nextToken) {
					this.$confirm('使用完整功能，请登录使用！', '提示', {
						confirmButtonText: '去登录',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						this.$router.push({
							path: '/login',
							// query: {
							//   id: 1,
							// },
						})
					}).catch(() => {

					});
					return
				}

				let item = scope
				console.log('id', item)
				let obj = {
					meetId: item.id,
					school_name: item.school_name || '',
					lat: item.work_lat || '',
					lng: item.work_lng || '',
					meeting_address: item.meeting_address || '',
					pdf_url: item.pdf_url || '',
					meeting_name: item.meeting_name || '',
					sign_up_img: item.sign_up_img || '',
					sign_time: item.meeting_time + ' ' + item.meeting_hour,
					meeting_price: item.meeting_price == '0' ? '' : item.meeting_price,
					isBatch: false,
					isOther: false
				}

				if (scope.meeting_status == 6) {
					obj.isOther = true
					obj.meeting_price = ''
				}

				sessionStorage.setItem('meetObj', JSON.stringify(obj))
				sessionStorage.setItem('selectMeetList', JSON.stringify([scope]))
				// this.$uniapp.goPage(`/pages/service/signup?meetId=${item.id}&school_name=${item.school_name||''}&lat=${item.work_lat||''}&lng=${item.work_lng||''}&meeting_address=${item.meeting_address||''}&pdf_url=${item.pdf_url || ''}&meeting_name=${item.meeting_name||''}&sign_up_img=${item.sign_up_img}`)
				// sessionStorage.setItem('user', JSON.stringify({ name: 'Alice', id: 123 }));

				this.$router.push({
					path: '/signup',
					// query: {
					//   id: 1,
					// },
				})
			},
			handleClick(row) {
				this.getQrcode(row.id)
				this.dialogVisible = true
				// this.$router.push({
				// 	path: "/jobDetails",
				// 	// query: {
				// 	//   id: 1,
				// 	// },
				// });
			},
			beforeClose() {},
			closeElDialog() {
				this.dialogVisible = false
			},

			currentChange(page) {
				console.log(page)
				this.currentpage = page
				// this.currentpage = page
				// this.getEnterpriseList()
				this.getmyJobList()
			},
			previousPage() {
				if (this.currentpage > 1) {
					this.currentpage = this.currentpage - 1
					this.getmyJobList()
				}
			},
			nextPage() {
				if (!this.isNextPage) {
					this.currentpage++
					this.getmyJobList()
				}
			},
			getMySchoolMeeting() {
				return new Promise((resolve, reject) => {
					let obj = {
						admin_id: this.schoolInfo.admin_id,
					}
					this.$util.post('v2/school_job/getMySchoolMeeting', obj, (res) => {
						if (res.code === 200) {
							this.regLength = res.data.length
							let idList = []
							res.data.forEach((item, index, arr) => {
								idList.push(item.id)
							})
							this.idList = idList
							resolve(res.data)
						} else {
							resolve([])
						}
					})
				})
			},

		},
	}
</script>
<style lang="less">
	// #meeting .tableContainer 
	#meeting .tableHeader .el-checkbox__inner {
		border: 1px solid #409EFF !important;
	}

	#meeting .signAll {
		background: #FF6600 !important;
		border-color: #FF6600 !important;
		padding: 12px 15px !important;
		font-size: 16px !important;
	}

	#meeting .el-upload-dragger {
		width: 720px !important;
	}

	#meeting .searchContainer .el-select {
		min-width: 120px !important;
		width: 100% !important;
		/* max-width: 265px !important; */
	}

	#meeting.el-table .el-table__cell {
		padding: 10px 0 !important;

	}

	#meeting.header-row-class-name {
		.cell {
			font-size: 14px !important;
			font-size: bold !important;

			transform: scale(1.03);
		}

	}

	/* #positionManagement .searchContainer .el-input__inner {
		background-color: #F0F4FA !important;
		color: #000;
	}
	
	#positionManagement .searchContainer .el-tag.el-tag--info {
		background: #fff !important;
		border-color: #fff;
	}
	
	#positionManagement .searchContainer .el-input__inner::-moz-placeholder {
		color: #000;
	}
	
	#positionManagement .searchContainer .el-input__inner::-ms-input-placeholder {
		color: #000;
	}
	
	#positionManagement .searchContainer .el-input__inner::-webkit-input-placeholder {
		color: #000;
	} */

	#meeting .searchContainer .el-date-editor {
		min-width: 175px !important;
		/* max-width: 265px !important; */
	}

	#meeting .has-gutter .el-checkbox {
		// display: none !important;
	}

	#meeting .searchContainer .el-date-editor {
		min-width: 175px !important;
		/* max-width: 265px !important; */
	}

	#meeting .searchContainer .el-input {
		min-width: 120px !important;
		/* max-width: 265px !important; */
	}

	#meeting .el-table .cell {
		text-align: center !important;
		// font-weight:bold !important;
		// font-size: 16px !important;
	}

	#meeting .el-table__header th {
		background: #e9eeff;
		font-weight: bold !important;
		color: #2a2929 !important;
	}

	#meeting .el-table__body td {
		background: #f9fbff;
	}

	/* .tableContainer .compile .el-button--primary {
		background-color: #4F8FF0;
		border-color: #4F8FF0;
	} */

	.tableContainer .delete .el-button--primary {
		background-color: #dc7777;
		border-color: #dc7777;
	}

	#meeting .preview .el-dialog {
		background: initial;
		box-shadow: initial;
	}


	#meeting .warning-row td {
		background: #1d2646;
	}

	#meeting .warning-row .item-main-box .item-right .item-1 {
		color: #ffffff;
	}

	#meeting .warning-row .holdingTime {
		color: #ffffff;
	}

	#meeting .warning-row .meettype {
		color: #ffffff !important;
	}

	#meeting .warning-row .item-1 {
		color: #ffffff !important;
	}

	#meeting .warning-row .deadline {
		color: #ffffff !important;

	}

	#meeting .warning-row .compile {
		width: 80px !important;
		color: #000000 !important;
		background: #cad6ff !important;
		opacity: 1 !important;
		text-align: center !important;
		padding: 10px 0 !important;
	}

	#meeting .compile {
		width: 80px !important;
		text-align: center !important;
		padding: 10px 0 !important;

	}

	#meeting .warning-row .payFees {
		width: 100% !important;
		color: #9db3fe !important;
		background-color: #1d2646 !important;
		border-color: #1d2646 !important;
		font-weight: 600;
		// cursor:pointer;
	}

	#meeting .warning-row .payFees1 {
		width: 100% !important;
		color: #ffffff;
		background-color: #1d2646 !important;
		border-color: #1d2646 !important;
		font-weight: 600;
		// cursor:pointer;
	}

	#meeting .payFees {
		width: 100% !important;
		color: #000000;
		background-color: #f9fbff !important;
		border-color: #f9fbff !important;
		cursor: auto;
	}
</style>
<style lang="less" scoped>
	.fade-enter-from,
	.fade-leave-to {
	  opacity: 0;
	}
	.fade-enter-active,
	.fade-leave-active {
	  transition: opacity 0.3s ease;
	}
	
	
	
	.container {
		width: 100%;
		position: relative;

		.headerContainer {
			width: 100%;
			padding: 20px 0 20px 0;
			border-bottom: 1px solid #eeeeee;
			display: flex;
			align-items: center;
			margin-bottom: 25px;

			.title {
				margin-right: 20px;
				font-weight: bold;
				font-size: 16px;
				color: #333;
			}

			.el-button--primary {
				font-size: 14px !important;
				// background-color: #0084FF !important;
				// border-color: #0084FF !important;
			}
		}

		.sortContainer {
			padding: 0 40px;
			// width: calc(100vw - 210px);
			box-sizing: border-box;

			.screenContainer {
				display: flex;
				// align-items: center;
				margin-bottom: 10px;
				margin-top: 10px;
			}

			.searchContainer {
				flex: 1;
				// padding-left: 8px;
				// display: flex;
				// align-items: center;
				// flex-wrap: wrap;

				// display: grid;
				// grid-template-columns: repeat(4, 1fr);
				// grid-gap: 10px 10px;
				margin-right: 10px;

				// .searchItem {
				// 	// flex: 1;
				// 	// width: 100%;
				// 	display: flex;
				// 	align-items: center;
				// 	// margin-right: 10px;
				// 	// margin-bottom: 10px;

				// 	.iptName {
				// 		// width:100px;
				// 		text-align: left;
				// 		font-weight: 400;
				// 		font-size: 14px;
				// 		color: #333;
				// 		padding-right: 5px;
				// 		white-space: nowrap;
				// 		// min-width: 100px;
				// 	}

				// 	.iptName1 {
				// 		// margin-left: 10px;
				// 	}
				// }

				.screenItem {
					display: flex;
					align-items: baseline;

					.left {
						width: 30px;
						font-weight: 400;
						font-size: 14px;
						color: #000;
						margin-right: 8px;
						margin-left: 9px;
						font-weight: 600;
					}

					.right {
						flex: 1;
						display: flex;
						align-items: center;
						flex-wrap: wrap;


					}

					.item {
						font-weight: 400;
						font-size: 14px;
						color: #818080;
						padding: 1px 5px;
						border: 1px solid #ffffff;
						border-radius: 20px;
						margin: 0 3px 3px 0;

						cursor: pointer;
					}

					.active {
						border: 1px solid #1E40AF;
						color: #1E40AF;
					}
				}

			}

			.btnContainer {
				// width: 20%;
				display: flex;
				align-items: center;
				// padding-right: 15px;
				border: 1px solid #dcdfe6;
				// border-right: none;
				box-sizing: border-box;
				height: 39px;
				border-radius: 4px;
				padding-right: 10px;
				width: 270px;

				.searchLeft {
					// height: 39px;
					// width: 140px;
					flex: 1;
					display: flex;
					align-items: center;
					padding-left: 10px;
					box-sizing: border-box;

					img {
						width: 14px;
						height: 14px;
						margin-right: 4px;
					}

					input {
						// width: 120px;
						flex: 1;
						height: 35px;
						outline: none;
						border: none;
						margin: 0 10px;
					}

					input::placeholder {
						color: #606266;
						font-size: 14px;
						opacity: 0.6;
					}
				}

				.btn {
					// width: 70px;
					// height: 39px;
					width: 30px;
					flex-shrink: 0;
					white-space: nowrap;
					display: flex;
					align-items: center;
					justify-content: center;
					// background: #fd8342;
					border-radius: 5px;
					font-size: 0;
					cursor: pointer;

					img {
						width: 16px;
						height: 16px;
						margin-right: 10px;
					}

					div {

						font-weight: 400;
						font-size: 14px;
						color: #004eff;
					}
				}
			}


		}

		.listContainer {
			padding: 0 40px;
			// padding: 0 40px;

			// .title {
			// 	font-weight: bold;
			// 	font-size: 18px;
			// 	color: #2D3C50;
			// 	margin-bottom: 20px;
			// 	margin-left: 8px;
			// }
			.tableContainer {
				width: 100%;
				// min-width: 1333px;
				// height: 602px;
			}

		}
	}

	.preview {
		.text {
			font-weight: 400;
			font-size: 14px;
			color: #2a2929;
			// margin-bottom: 5px;
		}

		.btn {
			font-weight: 400;
			font-size: 14px;
			color: #004eff;
			cursor: pointer;
		}
	}

	.paging {
		box-sizing: border-box;
		min-width: 1022px;
		width: calc(100vw - 180px);
		;
		padding: 10px 76px;
		display: flex;
		align-items: center;
		justify-content: space-between;
		z-index: 200;
		position: fixed;
		left: 180px;
		right: 0;
		bottom: 0;
		background: #ffffff;
		box-shadow: 0 0 10px rgba(0, 0, 0, .3);

		.pagingLeft {
			display: flex;
			align-items: center;
		}
	}

	.qrcodeContainer {
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: center;

		.qrcode {
			padding: 50px 50px;
			// width: 410px;
			// height: 390px;
			background: #ffffff;
			border-radius: 10px;
			border: 4px solid #0084ff;

			display: flex;
			align-items: center;
			justify-content: center;
			flex-direction: column;
			font-size: 0;

			.qrcodeImage { position: relative; width: 208px; height: 245px; }
			.qrcodeImg {
				width: 208px;
				height: 208px;
				margin-bottom: 37px;
			}
			.qrcodeLogo { position: absolute; top: 0; left: 0; right: 0; width: 90px; height: 90px; border-radius: 50%; margin: 58px auto; }

			.hite1 {
				font-weight: bold;
				font-size: 16px;
				color: #333333;
				margin-bottom: 17px;
			}

			.hite2 {
				font-weight: 500;
				font-size: 16px;
				color: #333333;
			}
		}
	}

	.elDialog {
		position: relative;
		font-size: 0;

		.main {
			box-sizing: border-box;
			padding: 30px 50px 50px 50px;
			background: #ffffff;
			border-radius: 10px;

			.title {
				font-weight: bold;
				font-size: 16px;
				color: #2a2929;
				margin-bottom: 30px;
			}
		}

		.close {
			position: absolute;
			top: -28px;
			right: -28px;
			width: 32px;
			height: 32px;
			cursor: pointer;
		}
	}

	.companyInfo {
		width: 100%;
		padding: 20px 0 20px 0;
		border-bottom: 1px solid #eeeeee;
		font-size: 0;
		display: flex;
		align-items: center;
		margin-bottom: 5px;

		// img {
		// 	width: 57px;
		// 	height: 57px;
		// 	border-radius: 50%;
		// 	background: #003987;
		// 	margin-right: 10px;
		// }

		.companyInfoRight {
			display: flex;
			justify-content: center;
			flex-direction: column;

			.companyInfoName {
				font-weight: 500;
				font-size: 18px;
				color: #2d3c50;
				margin-bottom: 10px;
			}

			.tags {
				display: flex;
				align-items: center;

				.item {
					padding: 2px 4px;
					border-radius: 5px;
					border: 1px solid #aeaeae;
					font-weight: 500;
					font-size: 12px;
					color: #aeaeae;
					margin-right: 5px;
				}
			}
		}
	}

	.item-main-box {
		display: flex;

		img {
			width: 90px;
			height: 72px;
			border-radius: 2px;
		}

		.item-right {
			flex: 1;
			padding-left: 10px;
			box-sizing: border-box;

			.item-1 {
				text-align: left;
				// height: 38px;
				// line-height: 18px;
				color: #000000;
				font-weight: 600;
			}

			.item-2 {
				text-align: left;
				// margin-top: 20px;
				color: #000000;
				font-weight: 600;

				b {
					color: #1e68ff;
				}
			}
		}
	}

	.majorbox {
		flex: 1;
		// width: 165px;
		border-radius: 4px;
		border: 1px solid #dcdfe6;
		cursor: pointer;
		display: flex;
		align-items: center;
		padding: 0 10px 0 15px;
		font-size: 14px;
	}

	.majorbox:hover {
		border: 1px solid #c0c4cc;
	}

	.majorBox {
		// width: 200px;
		height: 40px;
		line-height: 40px;
		font-size: 14px;
		color: #6b7280;
		flex: 1;
	}




	.applyContainer {
		display: grid;
		grid-template-columns: repeat(3, 1fr);
		grid-gap: 10px 10px;
		margin-top: 10px;

		.item {
			display: flex;
			align-items: center;
			justify-content: space-between;
			background: #E3F7EE;
			padding: 16px 20px;
			border-radius: 10px;
			cursor: pointer;

			.left {
				.title {
					font-weight: 500;
					font-size: 18px;
					color: #333333;
					margin: 0 12px 0 0;
				}

				.subheading {
					display: flex;
					align-items: center;
					font-size: 0;

					.applyLink {
						font-weight: 500;
						font-size: 14px;
						
                        color: #d98b32;
					}
				}

				.description {
					margin-top: 6px;
					font-size: 13px;
					line-height: 18px;
					color: #818080;
					white-space: nowrap;
				}
			}

			.right {
				font-size: 0;

				img {
					width: 50px;
					height: 50px;
				}
			}
		}

		.item:nth-child(2) .left .subheading .applyLink {
            color: #3487eb;
		}

		.item:nth-child(3) .left .subheading .applyLink {
			color: #35ba8a;
		}
	}





	.tableHeader {
		display: flex;
		align-items: center;
		width: 100%;
		height: 46px;
		background: #e9eeff;
		// padding: 0 15px 0 0;

		div {
			text-align: center;
			font-weight: bold;
			color: #2a2929;
			font-size: 14px;
			padding: 0 10px;
		}
	}

	.routeColumn,
	.meetingTimeColumn,
	.commonColumn {
		box-sizing: border-box;
		min-width: 0;
		width: auto !important;
	}

	.routeColumn {
		flex: 9 1 0;
	}

	.meetingTimeColumn {
		flex: 6 1 0;
		white-space: nowrap;
	}

	.commonColumn {
		flex: 3 1 0;
	}

	@media screen and (min-width: 1600px) {
		.routeColumn {
			flex: 6 1 0;
		}
	}

	.tableBody {
		min-height: 0;
		// display: flex;
		// align-items: center;
		width: 100%;
		// height: 46px;
		background: #f9fbff;
		margin-bottom: 0;

		.item {
			display: flex;
			align-items: center;
			padding: 12px 10px;
			// margin: 0 10px;
		}

		.checkboxContainer {
			justify-content: center;
			padding: 0 10px;
		}

		.jobfairname {
			font-size: 0;

			.school-cover {
				position: relative;
				flex-shrink: 0;
				width: 108px;
				height: 72px;
				margin-right: 10px;
				overflow: hidden;
				background: #f5f5f5;

				.school-cover__background {
					position: absolute;
					inset: 0;
					z-index: 1;
					width: 100%;
					height: 100%;
					object-fit: cover;
				}

				.school-cover__copy {
					position: relative;
					z-index: 2;
					box-sizing: border-box;
					display: flex;
					flex-direction: column;
					justify-content: center;
					width: 100%;
					height: 100%;
					padding: 4px 0 7px;
					font-family: Arial, "Microsoft YaHei", "PingFang SC", sans-serif;
					font-weight: 700;
					text-align: center;
				}

				.school-cover__season {
					font-size: 12px;
					font-weight: 900;
					line-height: 18px;
				}

				.school-cover__name {
					display: block;
					margin-top: 1px;
					overflow: hidden;
					font-weight: 700;
					white-space: nowrap;
				}

				.school-cover__name--large {
					font-size: 14px;
					line-height: 16px;
				}

				.school-cover__name--medium {
					font-size: 12px;
					line-height: 14px;
				}

				.school-cover__name--small {
					font-size: 10px;
					line-height: 10px;
				}

				.school-cover__name--two-line {
					font-size: 10px;
					line-height: 13px;
					white-space: nowrap;
				}
			}

			.item-1 {
				text-align: left;
				color: #000000;
				font-weight: 600;
				font-size: 14px;
			}
		}

		.holdingTime {
			color: #333;
			font-weight: 600;
			font-size: 14px;
			white-space: nowrap;
		}

		.assemblyRoom {
			font-size: 14px;
		}

		.cutOff {
			font-size: 14px;
			font-weight: 600;
			color: #333;
			text-align: center;
		}

		.cost {
			text-align: center;
			font-size: 14px;
			font-weight: 600;
			color: #333;
		}
	}

	.lineSelectAll {
		display: flex;
		align-items: center;
		margin-left: auto;
		margin-right: 40px;
		color: #333;
		font-size: 16px;
		font-weight: 600;

		span {
			margin-right: 8px;
		}
	}

	.lineDescription {
		display: flex;
		align-items: center;
		margin-left: 16px;
		color: #333;
		font-size: 14px;
		white-space: nowrap;

		.lineDescriptionLabel {
			padding: 4px 6px;
			margin-right: 8px;
			color: #3d876f;
			background: #dff3ef;
			border-radius: 3px;
            font-weight:600;
		}

		.lineDescriptionDetail {
			margin-left: 12px;
			color: #1e40af;
			font-weight: 600;
           cursor: pointer;
		}
	}

	.serviceDetailDialog {
		top: 50%;
		margin: 0 !important;
		transform: translateY(-50%);
		border-radius: 8px;

		.el-dialog__header {
			display: none;
		}

		.el-dialog__body {
			padding: 16px 22px 18px;
		}
	}

	.serviceDetailHeader {
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 16px;
		font-weight: 600;
		color: #333;
		position: relative;

		i {
			position: absolute;
			right: 0;
			font-size: 16px;
			font-weight: 400;
			cursor: pointer;
		}
	}

	.serviceDetailContent {
		margin-top: 18px;
		color: #000000;
		font-size: 14px;
		line-height: 21px;

		p {
			margin: 0 0 3px;
		}
	}

	.serviceDetailFooter {
		display: flex;
		justify-content: center;
		margin-top: 34px;

		.el-button {
			width: 96px;
		}
	}
	.showAllContainer{
		width: 100%;
		display: flex;
		align-items: center;
		// justify-content: center;
		background: #e9eeff;
		padding-left: 50px;
		.showAll{
			padding: 10px;
			display: flex;
			align-items: center;
			font-size: 0;
			cursor: pointer;
			img{
				width: 15px;
				height: 15px;
			}
			div{
				font-size: 16px;
				color:#818080;
				margin: 0 10px;
			}
		}
	}
	
	
</style>
<style>
	.serviceDetailDialog {
		top: 50%;
		left: 50%;
		margin: 0 !important;
		transform: translate(-50%, -50%);
	}

	.serviceDetailDialog .el-dialog__header {
		display: none;
	}

	.serviceDetailDialog .el-dialog__body {
		padding: 16px 22px 18px;
	}

	@supports (-webkit-touch-callout: none) {
		.paging {
			padding: 10px 56px;
		}
	}
</style>
